import React from 'react';

const AboutUSVG = () => (
  <svg
    className="prefix__animated"
    id="prefix__freepik_stories-team-goals"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500">
    <style>
      {
        "@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes zoomOut{0%{opacity:0;transform:scale(1.5)}to{opacity:1;transform:scale(1)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes lightSpeedRight{60%{transform:skewX(10deg);opacity:1}80%{transform:skewX(-2deg)}}@keyframes lightSpeedLeft{60%{transform:skewX(-10deg);opacity:1}80%{transform:skewX(2deg)}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#prefix__freepik_stories-team-goals:not(.prefix__animated) .prefix__animable{opacity:0}"
      }
    </style>
    <g
      id="prefix__freepik--Plant--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "74.5221px 299.355px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--Plants--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "74.5221px 299.355px",
        }}
      >
        <path
          d="M85.38 329.19l7.62-4.37s4.5-18.72 2.71-35.56c-2.53-23.67-18.11-32.58-24-30.54s-7.64 8.93 2.17 23c5.69 8.35 12.8 25.68 11.5 47.47z"
          style={{
            transformOrigin: "81.5186px 293.814px",
          }}
          id="prefix__ely5z09h3qk9p"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__eln86h189oh58">
          <g
            style={{
              transformOrigin: "81.5186px 293.814px",
            }}
            className="prefix__animable"
            id="prefix__eltc96qdod95p"
            opacity={0.65}
          >
            <path
              d="M85.38 329.19l7.62-4.37s4.5-18.72 2.71-35.56c-2.53-23.67-18.11-32.58-24-30.54s-7.64 8.93 2.17 23c5.69 8.35 12.8 25.68 11.5 47.47z"
              style={{
                transformOrigin: "81.5186px 293.814px",
              }}
              id="prefix__elrw4tonmfhmp"
              className="prefix__animable"
              fill="#fff"
            />
          </g>
        </g>
        <path
          d="M88.52 320h-.08a.52.52 0 01-.41-.61c4.15-21.84-3.48-46.38-12.93-56.59a.53.53 0 11.77-.72c9.62 10.4 17.4 35.34 13.19 57.5a.54.54 0 01-.54.42z"
          style={{
            transformOrigin: "82.574px 290.935px",
          }}
          id="prefix__elx99fl0ex6n"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M66.33 340.19c-1.13.57-4.13-2-5-2.62a10.58 10.58 0 01-3.29-4.18 9.86 9.86 0 01-.57-5.95 22.41 22.41 0 01.9-3.1c.35-1 .69-2 1-3a7.72 7.72 0 00.6-3c-.16-2.1-1.93-3.65-3.55-5-1.79-1.49-3.63-3.43-3.5-5.93a8.84 8.84 0 012.48-5.14c1.27-1.46 2.77-2.73 3.93-4.28a6.13 6.13 0 001.46-3.83 6.4 6.4 0 00-.73-2.48 35.63 35.63 0 01-2.42-5c-.52-1.78-.32-4 1.11-5.15a5.76 5.76 0 014.37-.85 9.77 9.77 0 013.94 1.61c3.87 2.42 5.91 7.25 10 9.16a40.84 40.84 0 005 1.51 6.33 6.33 0 014.07 3.1c1.4 3.18-1.68 6.85-.75 10.19.82 3 3.59 4.22 5 6.92a6.28 6.28 0 01.56 3.85 18.38 18.38 0 01-1.94 6.36 57.3 57.3 0 01-3.82 5.87s-18.67 10.85-18.85 10.94z"
          style={{
            transformOrigin: "71.9723px 310.416px",
          }}
          id="prefix__el57bz8owddng"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el8jkmkvvai17">
          <g
            style={{
              transformOrigin: "71.9723px 310.416px",
            }}
            className="prefix__animable"
            id="prefix__elr53kbi51ng"
            opacity={0.3}
          >
            <path
              d="M66.33 340.19c-1.13.57-4.13-2-5-2.62a10.58 10.58 0 01-3.29-4.18 9.86 9.86 0 01-.57-5.95 22.41 22.41 0 01.9-3.1c.35-1 .69-2 1-3a7.72 7.72 0 00.6-3c-.16-2.1-1.93-3.65-3.55-5-1.79-1.49-3.63-3.43-3.5-5.93a8.84 8.84 0 012.48-5.14c1.27-1.46 2.77-2.73 3.93-4.28a6.13 6.13 0 001.46-3.83 6.4 6.4 0 00-.73-2.48 35.63 35.63 0 01-2.42-5c-.52-1.78-.32-4 1.11-5.15a5.76 5.76 0 014.37-.85 9.77 9.77 0 013.94 1.61c3.87 2.42 5.91 7.25 10 9.16a40.84 40.84 0 005 1.51 6.33 6.33 0 014.07 3.1c1.4 3.18-1.68 6.85-.75 10.19.82 3 3.59 4.22 5 6.92a6.28 6.28 0 01.56 3.85 18.38 18.38 0 01-1.94 6.36 57.3 57.3 0 01-3.82 5.87s-18.67 10.85-18.85 10.94z"
              style={{
                transformOrigin: "71.9723px 310.416px",
              }}
              id="prefix__ele6j8cypc4wk"
              className="prefix__animable"
              fill="#fff"
            />
          </g>
        </g>
        <path
          d="M77.29 334.48a.51.51 0 01-.46-.54c1.81-19.64-6.37-41.84-12.79-48.5a.49.49 0 010-.7.5.5 0 01.7 0c6.56 6.79 14.91 29.36 13.07 49.28a.5.5 0 01-.52.46z"
          style={{
            transformOrigin: "70.9809px 309.539px",
          }}
          id="prefix__elunebywyj0wk"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M75.34 310.26h-.15a66.27 66.27 0 00-14.17-3 .49.49 0 01-.44-.54.47.47 0 01.54-.45 67.89 67.89 0 0114.41 3.08.49.49 0 01.3.63.5.5 0 01-.49.28z"
          style={{
            transformOrigin: "68.2183px 308.263px",
          }}
          id="prefix__elnjqkzf4gxy"
          className="prefix__animable"
          fill="#fff"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Floor--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "248.07px 379.95px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomOut",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--BullsEye--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "248.07px 379.95px",
        }}
      >
        <ellipse
          cx={248.07}
          cy={379.95}
          rx={193.15}
          ry={111.52}
          style={{
            transformOrigin: "248.07px 379.95px",
          }}
          id="prefix__elmeq0sasy5fl"
          className="prefix__animable"
          fill="#f0f0f0"
        />
        <path
          d="M129.7 448.28c-65.37-37.74-65.44-98.82-.14-136.43s171.28-37.61 236.73 0 65.52 98.69.14 136.43-171.36 37.72-236.73 0z"
          style={{
            transformOrigin: "248.025px 380.11px",
          }}
          id="prefix__el5amno673sd2"
          className="prefix__animable"
          fill="#fafafa"
        />
        <ellipse
          cx={248.07}
          cy={379.95}
          rx={141.64}
          ry={81.78}
          style={{
            transformOrigin: "248.07px 379.95px",
          }}
          id="prefix__eljyej5jojpap"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <ellipse
          cx={248.07}
          cy={379.95}
          rx={115.89}
          ry={66.91}
          style={{
            transformOrigin: "248.07px 379.95px",
          }}
          id="prefix__elm0kwkua1cd"
          className="prefix__animable"
          fill="#fafafa"
        />
        <ellipse
          cx={248.07}
          cy={379.95}
          rx={90.14}
          ry={52.04}
          style={{
            transformOrigin: "248.07px 379.95px",
          }}
          id="prefix__el2rvadtd7gqu"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <path
          d="M202.54 406.23c-25.14-14.52-25.14-38.05 0-52.57s65.73-14.41 90.65.23 24.92 38.18 0 52.57-65.51 14.29-90.65-.23z"
          style={{
            transformOrigin: "247.783px 380.013px",
          }}
          id="prefix__elon9yzeemyhg"
          className="prefix__animable"
          fill="#fafafa"
        />
        <ellipse
          cx={248.07}
          cy={379.95}
          rx={38.63}
          ry={22.3}
          style={{
            transformOrigin: "248.07px 379.95px",
          }}
          id="prefix__eloq91pxw7e3q"
          className="prefix__animable"
          fill="#e0e0e0"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Shadows--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "265.845px 378.034px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
        animationDelay: "0s",
      }}
    >
      <ellipse
        id="prefix__freepik--Shadow--inject-93"
        cx={408.38}
        cy={329.83}
        rx={28.83}
        ry={16.64}
        style={{
          transformOrigin: "408.38px 329.83px",
        }}
        className="prefix__animable"
        fill="#ebebeb"
      />
      <g id="prefix__freepik--shadow--inject-93">
        <ellipse
          cx={340.58}
          cy={381.99}
          rx={48.02}
          ry={27.72}
          style={{
            transformOrigin: "340.58px 381.99px",
          }}
          className="prefix__animable"
          id="prefix__elx3kiy4nnesd"
          opacity={0.15}
        />
      </g>
      <g id="prefix__freepik--shadow--inject-93">
        <ellipse
          cx={298.02}
          cy={323.21}
          rx={48.02}
          ry={27.72}
          style={{
            transformOrigin: "298.02px 323.21px",
          }}
          className="prefix__animable"
          id="prefix__elxxh48ilxd7"
          opacity={0.15}
        />
      </g>
      <g id="prefix__freepik--shadow--inject-93">
        <ellipse
          cx={142.5}
          cy={378.03}
          rx={48.02}
          ry={27.72}
          style={{
            transformOrigin: "142.5px 378.03px",
          }}
          className="prefix__animable"
          id="prefix__el2gj37s23noq"
          opacity={0.15}
        />
      </g>
      <g id="prefix__elp8otliqyiks">
        <path
          d="M244.14 411.82c-11.16-6.43-29.23-6.43-40.38 0a22.9 22.9 0 00-3.87 2.78c-.7-.46-1.41-.91-2.17-1.35-18.76-10.83-49.16-10.83-67.92 0s-18.75 28.38 0 39.21 49.16 10.82 67.92 0c7-4.06 11.43-9.07 13.18-14.32 10.74 3.19 24.24 2.19 33.24-3 11.15-6.44 11.15-16.88 0-23.32z"
          style={{
            transformOrigin: "184.118px 432.853px",
          }}
          className="prefix__animable"
          id="prefix__elz0ckb29oqy"
          opacity={0.15}
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Clouds--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "392.655px 99.5126px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--clouds--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "392.655px 99.5126px",
        }}
      >
        <path
          d="M357.11 100.22l6.22 3.59a7.86 7.86 0 01-.05-.83v-1.8c0-3.2 2.25-4.5 5-2.9a9.75 9.75 0 013 2.88c.46-4 3.62-5.53 7.46-3.31a16.6 16.6 0 017.52 13v2.7a7.07 7.07 0 01-.64 3.12l5.17 3a6.15 6.15 0 012.78 4.83c0 1.78-1.24 2.5-2.78 1.61l-33.7-19.45a6.17 6.17 0 01-2.78-4.83c.02-1.78 1.26-2.5 2.8-1.61z"
          style={{
            transformOrigin: "373.94px 111.66px",
          }}
          id="prefix__ellzlxth3b1i"
          className="prefix__animable"
          fill="#ebebeb"
        />
        <path
          d="M426.66 99.3l-3.35-2.58v-7.38c0-5.84-4.66-12.63-9.73-15.55-5.06-2.93-9.16-.56-9.16 5.29v1.07a13.22 13.22 0 00-4.26-4.26c-3.64-2.1-6.6-.39-6.6 3.81v.49l-4.66-2.7c-2.4-1.38-4.35-.26-4.35 2.51a9.62 9.62 0 004.35 7.53l37.76 21.8c2.4 1.38 4.34.26 4.34-2.51a9.58 9.58 0 00-4.34-7.52z"
          style={{
            transformOrigin: "407.775px 91.2271px",
          }}
          id="prefix__el7qxyk3knh3x"
          className="prefix__animable"
          fill="#ebebeb"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Trophy--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "408.38px 283.957px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--trophy--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "408.38px 283.957px",
        }}
      >
        <path
          d="M382 297.45a4.12 4.12 0 01-3.89-2.47 4 4 0 01.47-4.22 1.31 1.31 0 111.95 1.75 1.46 1.46 0 000 1.39 1.51 1.51 0 001.49.92 1.48 1.48 0 001.36-1c.5-1.16.15-3.31-2.31-5.85-1.23-1.27-4.23-2.65-7.71-4.25-9.09-4.18-21.53-9.91-21.85-22-.24-9.08 5.27-13.33 10.51-14.28 6-1.08 11.76 1.73 13.41 6.53a1.31 1.31 0 01-2.48.86c-1.22-3.53-5.81-5.65-10.47-4.8-5.39 1-8.51 5.32-8.34 11.62.27 10.47 11.86 15.81 20.32 19.7 3.87 1.78 6.92 3.19 8.5 4.81 2.85 2.94 3.91 6.19 2.85 8.71a4.12 4.12 0 01-3.81 2.58z"
          style={{
            transformOrigin: "368.858px 272.331px",
          }}
          id="prefix__elqgo9khfb7w"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el39j7bnoe9ks">
          <g
            style={{
              transformOrigin: "368.858px 272.331px",
            }}
            className="prefix__animable"
            id="prefix__el0zpt70jijvr"
            opacity={0.2}
          >
            <path
              d="M382 297.45a4.12 4.12 0 01-3.89-2.47 4 4 0 01.47-4.22 1.31 1.31 0 111.95 1.75 1.46 1.46 0 000 1.39 1.51 1.51 0 001.49.92 1.48 1.48 0 001.36-1c.5-1.16.15-3.31-2.31-5.85-1.23-1.27-4.23-2.65-7.71-4.25-9.09-4.18-21.53-9.91-21.85-22-.24-9.08 5.27-13.33 10.51-14.28 6-1.08 11.76 1.73 13.41 6.53a1.31 1.31 0 01-2.48.86c-1.22-3.53-5.81-5.65-10.47-4.8-5.39 1-8.51 5.32-8.34 11.62.27 10.47 11.86 15.81 20.32 19.7 3.87 1.78 6.92 3.19 8.5 4.81 2.85 2.94 3.91 6.19 2.85 8.71a4.12 4.12 0 01-3.81 2.58z"
              id="prefix__elr5l2rkhvwzq"
              className="prefix__animable"
              style={{
                transformOrigin: "368.858px 272.331px",
              }}
            />
          </g>
        </g>
        <path
          d="M434.77 297.45a4.12 4.12 0 003.88-2.47 4 4 0 00-.47-4.22 1.31 1.31 0 10-1.95 1.75 1.41 1.41 0 010 1.39 1.54 1.54 0 01-2.85-.08c-.5-1.16-.15-3.31 2.31-5.85 1.24-1.27 4.24-2.65 7.71-4.25 9.09-4.18 21.53-9.91 21.85-22 .24-9.08-5.27-13.33-10.5-14.28-6-1.08-11.76 1.73-13.42 6.53a1.32 1.32 0 002.49.86c1.21-3.53 5.81-5.65 10.46-4.8 5.39 1 8.51 5.32 8.34 11.62-.27 10.47-11.86 15.81-20.32 19.7-3.87 1.78-6.92 3.19-8.5 4.81-2.84 2.94-3.91 6.19-2.84 8.71a4.11 4.11 0 003.81 2.58z"
          style={{
            transformOrigin: "447.905px 272.331px",
          }}
          id="prefix__elggyixvcz8el"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elv0ms3fxnklr">
          <path
            d="M434.77 297.45a4.12 4.12 0 003.88-2.47 4 4 0 00-.47-4.22 1.31 1.31 0 10-1.95 1.75 1.41 1.41 0 010 1.39 1.54 1.54 0 01-2.85-.08c-.5-1.16-.15-3.31 2.31-5.85 1.24-1.27 4.24-2.65 7.71-4.25 9.09-4.18 21.53-9.91 21.85-22 .24-9.08-5.27-13.33-10.5-14.28-6-1.08-11.76 1.73-13.42 6.53a1.32 1.32 0 002.49.86c1.21-3.53 5.81-5.65 10.46-4.8 5.39 1 8.51 5.32 8.34 11.62-.27 10.47-11.86 15.81-20.32 19.7-3.87 1.78-6.92 3.19-8.5 4.81-2.84 2.94-3.91 6.19-2.84 8.71a4.11 4.11 0 003.81 2.58z"
            style={{
              transformOrigin: "447.905px 272.331px",
            }}
            className="prefix__animable"
            id="prefix__elp5mt1teunc"
            opacity={0.1}
          />
        </g>
        <path
          d="M387.49 332.89a11.5 11.5 0 01-.6-1c-.05-.09-.09-.18-.14-.28a7.46 7.46 0 01-.37-.88c0-.09-.07-.18-.1-.27a7.64 7.64 0 01-.28-1.12 7.43 7.43 0 01-.09-1.15v-.34a7 7 0 01.09-.85l.06-.41c0-.26.12-.51.19-.76s.07-.25.12-.38a8.79 8.79 0 01.44-1.06l.19-.33c.14-.25.29-.5.46-.75s.2-.29.31-.43.15-.22.24-.33l.38-.44.2-.23c4.82-5.54 11.91-7.38 19.84-7.38s15 1.85 19.85 7.4l.17.19.4.46.25.35.29.4c.18.27.34.53.49.8.05.1.11.19.15.28a10 10 0 01.46 1.08c0 .11.07.23.1.34a8 8 0 01.2.81 2.2 2.2 0 01.06.37 6 6 0 01.07.85 2.71 2.71 0 010 .29 7.4 7.4 0 01-.38 2.31l-.09.24a8.18 8.18 0 01-.39.92c0 .08-.07.16-.12.24a9 9 0 01-.64 1.06 11.85 11.85 0 01-.91 1.13l-.07.07c-.3.33-.63.64-1 1l-.24.21c-.33.28-.67.54-1 .81-.09.06-.17.13-.27.19-.45.32-.93.63-1.45.93-8.78 5.08-23.05 5.08-31.83 0-.51-.3-1-.61-1.44-.92l-.3-.22q-.53-.37-1-.78l-.27-.23c-.34-.3-.65-.61-.94-.92l-.1-.11a11.51 11.51 0 01-.9-1.11.47.47 0 00-.09-.05z"
          style={{
            transformOrigin: "408.417px 327.77px",
          }}
          id="prefix__el0kv68hus3e7"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el85hcd7c27qy">
          <g
            style={{
              transformOrigin: "408.417px 327.77px",
            }}
            className="prefix__animable"
            id="prefix__elvffjq9a4jkj"
            opacity={0.15}
          >
            <path
              d="M387.49 332.89a11.5 11.5 0 01-.6-1c-.05-.09-.09-.18-.14-.28a7.46 7.46 0 01-.37-.88c0-.09-.07-.18-.1-.27a7.64 7.64 0 01-.28-1.12 7.43 7.43 0 01-.09-1.15v-.34a7 7 0 01.09-.85l.06-.41c0-.26.12-.51.19-.76s.07-.25.12-.38a8.79 8.79 0 01.44-1.06l.19-.33c.14-.25.29-.5.46-.75s.2-.29.31-.43.15-.22.24-.33l.38-.44.2-.23c4.82-5.54 11.91-7.38 19.84-7.38s15 1.85 19.85 7.4l.17.19.4.46.25.35.29.4c.18.27.34.53.49.8.05.1.11.19.15.28a10 10 0 01.46 1.08c0 .11.07.23.1.34a8 8 0 01.2.81 2.2 2.2 0 01.06.37 6 6 0 01.07.85 2.71 2.71 0 010 .29 7.4 7.4 0 01-.38 2.31l-.09.24a8.18 8.18 0 01-.39.92c0 .08-.07.16-.12.24a9 9 0 01-.64 1.06 11.85 11.85 0 01-.91 1.13l-.07.07c-.3.33-.63.64-1 1l-.24.21c-.33.28-.67.54-1 .81-.09.06-.17.13-.27.19-.45.32-.93.63-1.45.93-8.78 5.08-23.05 5.08-31.83 0-.51-.3-1-.61-1.44-.92l-.3-.22q-.53-.37-1-.78l-.27-.23c-.34-.3-.65-.61-.94-.92l-.1-.11a11.51 11.51 0 01-.9-1.11.47.47 0 00-.09-.05z"
              id="prefix__elur9mwlcipaj"
              className="prefix__animable"
              style={{
                transformOrigin: "408.417px 327.77px",
              }}
            />
          </g>
        </g>
        <path
          d="M389.59 321.73a24.54 24.54 0 0110.23-4.9 5.9 5.9 0 002.4-.77c.19-.26-.25-.54-1.1-.59a11.35 11.35 0 00-1.53 0 17.61 17.61 0 00-7.59 3.25 17.22 17.22 0 00-3 2.77c-.63.87-.31.99.59.24zm27.41-4.9a24.49 24.49 0 0110.22 4.9c.91.75 1.23.63.57-.22a17.22 17.22 0 00-3-2.77 17.61 17.61 0 00-7.59-3.25 11.35 11.35 0 00-1.53 0c-.84 0-1.29.33-1.1.59a5.91 5.91 0 002.43.75zm-16.69 2.47c1-.64 1.64-1.35 1.55-1.66s-1-.46-2.14-.16a27.56 27.56 0 00-10.34 5.58 5.86 5.86 0 00-1.95 3.53 7 7 0 00.18 1.65c.27 1.15 1.34 1.21 2.1.31a46.92 46.92 0 0110.6-9.25zm15.36.7a3.48 3.48 0 00-2.79-.58c-.57.26-.64 1.26-.16 2.33a97.75 97.75 0 014.8 13.35 2 2 0 002.58 1.36 21.49 21.49 0 005.85-3.34 2.52 2.52 0 00.35-3.25 40.22 40.22 0 00-10.63-9.87zm11.76 3.06a27.48 27.48 0 00-10.34-5.58c-1.14-.3-2-.15-2.14.16s.57 1 1.56 1.66a47.14 47.14 0 0110.6 9.25c.75.9 1.83.84 2.09-.31a6.52 6.52 0 00.18-1.65 5.8 5.8 0 00-1.95-3.53zm-16.22-1.63a1.84 1.84 0 00-1.83-1.15 11.9 11.9 0 01-1.95 0 1.84 1.84 0 00-1.83 1.15 126.21 126.21 0 00-4.81 14.34 2 2 0 001.54 2.48 36.44 36.44 0 0012.15 0 2 2 0 001.54-2.48 126.21 126.21 0 00-4.81-14.34zm-7.28-2a3.45 3.45 0 00-2.78.58 39.91 39.91 0 00-10.63 9.87 2.52 2.52 0 00.34 3.25 21.49 21.49 0 005.85 3.34 2 2 0 002.59-1.36 99.11 99.11 0 014.79-13.35c.48-1.08.41-2.08-.16-2.34z"
          style={{
            transformOrigin: "408.405px 327.102px",
          }}
          id="prefix__ellauj0ijcjck"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elw1scgjz28ur">
          <path
            d="M389.59 321.73a24.54 24.54 0 0110.23-4.9 5.9 5.9 0 002.4-.77c.19-.26-.25-.54-1.1-.59a11.35 11.35 0 00-1.53 0 17.61 17.61 0 00-7.59 3.25 17.22 17.22 0 00-3 2.77c-.63.87-.31.99.59.24zm27.41-4.9a24.49 24.49 0 0110.22 4.9c.91.75 1.23.63.57-.22a17.22 17.22 0 00-3-2.77 17.61 17.61 0 00-7.59-3.25 11.35 11.35 0 00-1.53 0c-.84 0-1.29.33-1.1.59a5.91 5.91 0 002.43.75zm-16.69 2.47c1-.64 1.64-1.35 1.55-1.66s-1-.46-2.14-.16a27.56 27.56 0 00-10.34 5.58 5.86 5.86 0 00-1.95 3.53 7 7 0 00.18 1.65c.27 1.15 1.34 1.21 2.1.31a46.92 46.92 0 0110.6-9.25zm15.36.7a3.48 3.48 0 00-2.79-.58c-.57.26-.64 1.26-.16 2.33a97.75 97.75 0 014.8 13.35 2 2 0 002.58 1.36 21.49 21.49 0 005.85-3.34 2.52 2.52 0 00.35-3.25 40.22 40.22 0 00-10.63-9.87zm11.76 3.06a27.48 27.48 0 00-10.34-5.58c-1.14-.3-2-.15-2.14.16s.57 1 1.56 1.66a47.14 47.14 0 0110.6 9.25c.75.9 1.83.84 2.09-.31a6.52 6.52 0 00.18-1.65 5.8 5.8 0 00-1.95-3.53zm-16.22-1.63a1.84 1.84 0 00-1.83-1.15 11.9 11.9 0 01-1.95 0 1.84 1.84 0 00-1.83 1.15 126.21 126.21 0 00-4.81 14.34 2 2 0 001.54 2.48 36.44 36.44 0 0012.15 0 2 2 0 001.54-2.48 126.21 126.21 0 00-4.81-14.34zm-7.28-2a3.45 3.45 0 00-2.78.58 39.91 39.91 0 00-10.63 9.87 2.52 2.52 0 00.34 3.25 21.49 21.49 0 005.85 3.34 2 2 0 002.59-1.36 99.11 99.11 0 014.79-13.35c.48-1.08.41-2.08-.16-2.34z"
            style={{
              transformOrigin: "408.405px 327.102px",
            }}
            className="prefix__animable"
            id="prefix__el8m0a7kkaqzs"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <path
          d="M370.16 249c0 18.72 6.47 28.31 13.95 39.65 8.86 13.42 20.68 18.59 21.19 28a1.54 1.54 0 00.91 1.27 4.83 4.83 0 004.38 0 1.54 1.54 0 00.91-1.26c.21-9.45 12.32-14.63 21.18-28 7.49-11.34 14-20.78 14-39.65z"
          style={{
            transformOrigin: "408.42px 283.723px",
          }}
          id="prefix__elail6fwt6udq"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el3zj9juby7e2">
          <path
            d="M370.16 249c0 18.72 6.47 28.31 13.95 39.65 8.86 13.42 20.68 18.59 21.19 28a1.54 1.54 0 00.91 1.27 4.83 4.83 0 004.38 0 1.54 1.54 0 00.91-1.26c.21-9.45 12.32-14.63 21.18-28 7.49-11.34 14-20.78 14-39.65z"
            style={{
              transformOrigin: "408.42px 283.723px",
            }}
            className="prefix__animable"
            id="prefix__eljxjabvijxk"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <path
          d="M370.16 249.23c.07 18.53 6.51 28.09 13.95 39.37 8.86 13.42 20.68 18.59 21.19 28a1.54 1.54 0 00.91 1.27 3.46 3.46 0 00.9.36c-.32-9.13-3.73-13-10.62-21.79-9.37-11.91-14.92-25.46-4.87-27.4 0 0-15.19-18.57-18.95-20.13h-2.47a1.88 1.88 0 00-.04.32z"
          style={{
            transformOrigin: "388.635px 283.57px",
          }}
          id="prefix__elma2kyulf2"
          className="prefix__animable"
          fill="#0b345a"
        />
        <path
          d="M435.44 264.56c-14.93 8.62-39.13 8.62-54.06 0s-14.94-22.6 0-31.22 39.14-8.62 54.07 0 14.92 22.6-.01 31.22z"
          style={{
            transformOrigin: "408.411px 248.95px",
          }}
          id="prefix__elhb1piqzs8xh"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el8qct9vlezur">
          <path
            d="M435.44 264.56c-14.93 8.62-39.13 8.62-54.06 0s-14.94-22.6 0-31.22 39.14-8.62 54.07 0 14.92 22.6-.01 31.22z"
            style={{
              transformOrigin: "408.411px 248.95px",
            }}
            className="prefix__animable"
            id="prefix__elncmhdrj2dzg"
            fill="#fff"
            opacity={0.5}
          />
        </g>
        <path
          d="M432.6 262.92c-13.36 7.71-35 7.71-48.38 0s-13.37-20.22 0-27.94 35-7.71 48.39 0 13.39 20.23-.01 27.94z"
          style={{
            transformOrigin: "408.42px 248.948px",
          }}
          id="prefix__eld5oqmd5r8os"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elxo7imoqfel8">
          <path
            d="M432.6 262.92c-13.36 7.71-35 7.71-48.38 0s-13.37-20.22 0-27.94 35-7.71 48.39 0 13.39 20.23-.01 27.94z"
            style={{
              transformOrigin: "408.42px 248.948px",
            }}
            className="prefix__animable"
            id="prefix__ely39rwoksbo"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <path
          d="M394.54 230.9a40.56 40.56 0 00-10.32 4.1c-13.36 7.72-13.36 20.23 0 27.94a39.26 39.26 0 008 3.43c-9.6-16.23-4.07-32.12 2.32-35.47z"
          style={{
            transformOrigin: "384.37px 248.635px",
          }}
          id="prefix__elpgtbqna8r19"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elcy6kmy2ott">
          <path
            d="M432.6 253.35c-13.36-7.71-35-7.71-48.39 0a25.34 25.34 0 00-6.1 4.78 25 25 0 006.11 4.79c13.36 7.71 35 7.71 48.38 0a25.4 25.4 0 006.11-4.78 25.38 25.38 0 00-6.11-4.79z"
            style={{
              transformOrigin: "408.41px 258.135px",
            }}
            className="prefix__animable"
            id="prefix__el4wg87rrzqvf"
            fill="#0b345a"
            opacity={0.4}
          />
        </g>
        <g id="prefix__elumsvfo1b8b">
          <path
            d="M429.84 264.35c-12.48-5.81-30.38-5.81-42.86 0 12.48 5.8 30.38 5.8 42.86 0z"
            style={{
              transformOrigin: "408.41px 264.346px",
            }}
            className="prefix__animable"
            id="prefix__elyj2f97ncfrs"
            fill="#0b345a"
            opacity={0.4}
          />
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--Gears--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "309.289px 438.543px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--gears--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "309.289px 438.543px",
        }}
      >
        <g id="prefix__freepik--shadow--inject-93">
          <path
            d="M275.85 473.61a4.11 4.11 0 01-4-3.31l-.68-3.56a44.29 44.29 0 01-4.54-1.13l-6.93 3.21a4.71 4.71 0 01-2 .41 4.78 4.78 0 01-2.37-.6l-7.09-4.1a3.51 3.51 0 01-.3-6l3.71-2.68c-.17-.25-.34-.51-.5-.77l-8.67-.55a4 4 0 01-3.69-3.94v-5.27a4 4 0 013.7-3.94l8.66-.54c.16-.26.33-.52.5-.78l-3.65-2.67a3.52 3.52 0 01.3-6l7.1-4.09a4.9 4.9 0 014.33-.2l6.93 3.21c1.45-.44 3-.82 4.54-1.13l.68-3.56a4.11 4.11 0 014-3.31h10.43a4.13 4.13 0 014 3.31l.68 3.56c1.56.31 3.08.69 4.54 1.13l6.93-3.21a4.9 4.9 0 014.33.2l7.09 4.09a3.51 3.51 0 01.3 6l-3.71 2.68c.17.26.34.52.5.78l8.66.55a3.94 3.94 0 013.7 3.93v5.27a4 4 0 01-3.7 3.94l-8.66.55c-.16.26-.33.52-.5.77l3.72 2.68a3.52 3.52 0 01-.31 6l-7.09 4.1a4.78 4.78 0 01-2.37.6 4.71 4.71 0 01-2-.41l-6.93-3.21a45.62 45.62 0 01-4.54 1.13l-.68 3.56a4.11 4.11 0 01-4 3.31zm-5.26-30c-2.2 1.27-3.47 2.84-3.47 4.32s1.27 3 3.47 4.32a23.55 23.55 0 0021 0c2.17-1.25 3.41-2.81 3.41-4.25s-1.26-3.05-3.47-4.32a23.47 23.47 0 00-21 0z"
            style={{
              transformOrigin: "281.06px 447.965px",
            }}
            className="prefix__animable"
            id="prefix__elvv25xkd0fe9"
            opacity={0.15}
          />
        </g>
        <path
          d="M249.45 428.33v6.16a.6.6 0 00.28.47l3.25 2.33a1.61 1.61 0 01-.82.35l-9.45.6a1 1 0 00-.89.94v11.42a1 1 0 00.88.94l9.46.6a1.63 1.63 0 01.8.33l-3.26 2.35a.6.6 0 00-.28.47v6.17a.59.59 0 00.33.47l7.1 4.1a2 2 0 001.57.07l7.19-3.33a2.56 2.56 0 011.64-.1 43.25 43.25 0 005.58 1.33 1.33 1.33 0 011 1l.9 4.74a1.11 1.11 0 001.05.87h10.52a1.11 1.11 0 001.05-.87l.9-4.74a1.37 1.37 0 011-1 41.64 41.64 0 005.58-1.32 2.59 2.59 0 011.65.1l7.19 3.33a2 2 0 001.57-.07l7.09-4.1a.56.56 0 00.33-.48v-6.16a.6.6 0 00-.28-.47l-3.24-2.33a1.61 1.61 0 01.82-.35l9.45-.6a1 1 0 00.88-.94v-11.39a1 1 0 00-.89-.94l-9.45-.6a1.6 1.6 0 01-.8-.33l3.26-2.35a.6.6 0 00.28-.48v-6.15a.57.57 0 00-.33-.48l-7.09-4.1a2 2 0 00-1.57-.07l-7.2 3.28a2.56 2.56 0 01-1.64.1 42.15 42.15 0 00-5.59-1.32 1.36 1.36 0 01-1-1l-.9-4.74a1.13 1.13 0 00-1.06-.87h-10.45a1.13 1.13 0 00-1.06.87l-.89 4.74a1.39 1.39 0 01-1 1 41.79 41.79 0 00-5.59 1.32 2.56 2.56 0 01-1.64-.1l-7.19-3.33a2 2 0 00-1.57.07l-7.1 4.1a.6.6 0 00-.37.49zm43.6 20.4c-6.61 3.83-17.35 3.83-24 0a9.55 9.55 0 01-4.73-5.28 11 11 0 014.73-4.53c6.62-3.82 17.35-3.82 24 0 2.58 1.5 4.1 3.16 4.61 4.86a9.74 9.74 0 01-4.61 4.95z"
          style={{
            transformOrigin: "281.055px 444.89px",
          }}
          id="prefix__elv7ivctii9se"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elhr8mw2ghdyq">
          <path
            d="M249.45 428.33v6.16a.6.6 0 00.28.47l3.25 2.33a1.61 1.61 0 01-.82.35l-9.45.6a1 1 0 00-.89.94v11.42a1 1 0 00.88.94l9.46.6a1.63 1.63 0 01.8.33l-3.26 2.35a.6.6 0 00-.28.47v6.17a.59.59 0 00.33.47l7.1 4.1a2 2 0 001.57.07l7.19-3.33a2.56 2.56 0 011.64-.1 43.25 43.25 0 005.58 1.33 1.33 1.33 0 011 1l.9 4.74a1.11 1.11 0 001.05.87h10.52a1.11 1.11 0 001.05-.87l.9-4.74a1.37 1.37 0 011-1 41.64 41.64 0 005.58-1.32 2.59 2.59 0 011.65.1l7.19 3.33a2 2 0 001.57-.07l7.09-4.1a.56.56 0 00.33-.48v-6.16a.6.6 0 00-.28-.47l-3.24-2.33a1.61 1.61 0 01.82-.35l9.45-.6a1 1 0 00.88-.94v-11.39a1 1 0 00-.89-.94l-9.45-.6a1.6 1.6 0 01-.8-.33l3.26-2.35a.6.6 0 00.28-.48v-6.15a.57.57 0 00-.33-.48l-7.09-4.1a2 2 0 00-1.57-.07l-7.2 3.28a2.56 2.56 0 01-1.64.1 42.15 42.15 0 00-5.59-1.32 1.36 1.36 0 01-1-1l-.9-4.74a1.13 1.13 0 00-1.06-.87h-10.45a1.13 1.13 0 00-1.06.87l-.89 4.74a1.39 1.39 0 01-1 1 41.79 41.79 0 00-5.59 1.32 2.56 2.56 0 01-1.64-.1l-7.19-3.33a2 2 0 00-1.57.07l-7.1 4.1a.6.6 0 00-.37.49zm43.6 20.4c-6.61 3.83-17.35 3.83-24 0a9.55 9.55 0 01-4.73-5.28 11 11 0 014.73-4.53c6.62-3.82 17.35-3.82 24 0 2.58 1.5 4.1 3.16 4.61 4.86a9.74 9.74 0 01-4.61 4.95z"
            style={{
              transformOrigin: "281.055px 444.89px",
            }}
            className="prefix__animable"
            id="prefix__elsxqo42lylr"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <g id="prefix__elztlnipp8xe">
          <path
            d="M306.68 449.62a.75.75 0 00.1 1.16l2.37 1.7a1.62 1.62 0 01.83-.34l9.45-.6a1 1 0 00.89-.94v-7.39 1.24a1 1 0 01-.88.94L310 446a1.74 1.74 0 00-1.27.85 14.44 14.44 0 01-2.05 2.77zm6-21.22a.74.74 0 01-.28.41l-5.63 4a.76.76 0 00-.1 1.16 14.44 14.44 0 012 2.78 1.54 1.54 0 00.47.52l3.26-2.35a.58.58 0 00.28-.48z"
            style={{
              transformOrigin: "313.383px 440.44px",
            }}
            className="prefix__animable"
            id="prefix__elfqv3unzzcud"
            opacity={0.1}
          />
        </g>
        <g id="prefix__elobgewvl4ot">
          <path
            d="M269.09 434.9c6.62-3.82 17.34-3.83 24 0 4.19 2.41 5.73 5.77 4.62 8.89-.5-1.7-2-3.37-4.61-4.87-6.62-3.82-17.35-3.82-24 0a10.94 10.94 0 00-4.73 4.51c-.89-3 .69-6.21 4.72-8.53z"
            style={{
              transformOrigin: "281.094px 437.911px",
            }}
            className="prefix__animable"
            id="prefix__elveaww6yb77s"
            opacity={0.1}
          />
        </g>
        <path
          d="M241.86 450.6a1 1 0 00.88.94l9.46.6a1.16 1.16 0 01.46.14v-6.16a1.37 1.37 0 00-.48-.13l-9.45-.6a1 1 0 01-.87-.82zm7.61-16.11a.63.63 0 00.28.47l3.25 2.34a1.9 1.9 0 00.44-.51 14 14 0 011.91-2.66l.1-.12a.79.79 0 00.19-.33v-.12a.65.65 0 000-.24.69.69 0 00-.18-.35.77.77 0 00-.13-.12l-5.62-4-.13-.11a.44.44 0 01-.12-.19.4.4 0 010-.18zm0 27a.57.57 0 00.33.47l7.1 4.1a1.8 1.8 0 001.09.18v-6.14a1.83 1.83 0 01-1.1-.19l-7.1-4.09a.69.69 0 01-.33-.44zm46.34 1.14a2.47 2.47 0 01.71.16l7.18 3.34a1.93 1.93 0 00.65.12v-6.14a1.47 1.47 0 01-.64-.13l-7.19-3.34a2.32 2.32 0 00-.71-.16zM275 470.09a1.09 1.09 0 00.92.52h10.38a1 1 0 00.63-.22v-6.16a1 1 0 01-.63.24h-10.45a1.07 1.07 0 01-.85-.47z"
          style={{
            transformOrigin: "273.105px 449.49px",
          }}
          id="prefix__elnwygogw8ki"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el2qo88zyojnc">
          <path
            d="M241.86 450.6a1 1 0 00.88.94l9.46.6a1.16 1.16 0 01.46.14v-6.16a1.37 1.37 0 00-.48-.13l-9.45-.6a1 1 0 01-.87-.82zm7.61-16.11a.63.63 0 00.28.47l3.25 2.34a1.9 1.9 0 00.44-.51 14 14 0 011.91-2.66l.1-.12a.79.79 0 00.19-.33v-.12a.65.65 0 000-.24.69.69 0 00-.18-.35.77.77 0 00-.13-.12l-5.62-4-.13-.11a.44.44 0 01-.12-.19.4.4 0 010-.18zm0 27a.57.57 0 00.33.47l7.1 4.1a1.8 1.8 0 001.09.18v-6.14a1.83 1.83 0 01-1.1-.19l-7.1-4.09a.69.69 0 01-.33-.44zm46.34 1.14a2.47 2.47 0 01.71.16l7.18 3.34a1.93 1.93 0 00.65.12v-6.14a1.47 1.47 0 01-.64-.13l-7.19-3.34a2.32 2.32 0 00-.71-.16zM275 470.09a1.09 1.09 0 00.92.52h10.38a1 1 0 00.63-.22v-6.16a1 1 0 01-.63.24h-10.45a1.07 1.07 0 01-.85-.47z"
            style={{
              transformOrigin: "273.105px 449.49px",
            }}
            className="prefix__animable"
            id="prefix__el3gaj7olnzij"
            fill="#fff"
            opacity={0.7}
          />
        </g>
        <path
          d="M256.88 423.75l-7.1 4.1a.53.53 0 000 1l5.62 4a.75.75 0 01.1 1.16 14 14 0 00-2 2.78 1.76 1.76 0 01-1.28.85l-9.45.6a1 1 0 00-.89.94v5.27a1 1 0 00.89.94l9.45.6a1.76 1.76 0 011.28.85 13.68 13.68 0 002 2.78.75.75 0 01-.1 1.16l-5.62 4a.53.53 0 000 1l7.09 4.1a2 2 0 001.57.07l7.19-3.33a2.56 2.56 0 011.64-.1 43.8 43.8 0 005.59 1.33 1.37 1.37 0 011 1l.9 4.73a1.11 1.11 0 001.05.87h10.43a1.13 1.13 0 001-.87l.9-4.73a1.35 1.35 0 011-1 43.4 43.4 0 005.59-1.33 2.56 2.56 0 011.64.1l7.19 3.33a2 2 0 001.57-.07l7.09-4.1a.53.53 0 000-1l-5.62-4a.75.75 0 01-.1-1.16 13.68 13.68 0 002-2.78 1.76 1.76 0 011.5-.84l9.45-.6a1 1 0 00.89-.94v-5.27a1 1 0 00-.89-.94l-9.45-.6a1.76 1.76 0 01-1.28-.85 13.68 13.68 0 00-2-2.78.75.75 0 01.1-1.16l5.62-4a.53.53 0 000-1l-7.09-4.1a2 2 0 00-1.57-.07L296.5 427a2.56 2.56 0 01-1.64.1 42.15 42.15 0 00-5.59-1.32 1.36 1.36 0 01-1-1l-.9-4.74a1.13 1.13 0 00-1.06-.87h-10.45a1.13 1.13 0 00-1.06.87l-.89 4.74a1.39 1.39 0 01-1 1 41.79 41.79 0 00-5.59 1.32 2.56 2.56 0 01-1.64-.1l-7.19-3.33a2 2 0 00-1.61.08zm36.17 11.15c6.62 3.82 6.62 10 0 13.83s-17.35 3.83-24 0-6.62-10 0-13.83 17.38-3.82 24 0z"
          style={{
            transformOrigin: "281.11px 441.81px",
          }}
          id="prefix__elc2kf7cr64mt"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el3ri7ceq15b5">
          <g
            style={{
              transformOrigin: "281.08px 441.835px",
            }}
            className="prefix__animable"
            id="prefix__el98u70wa2c2c"
            opacity={0.55}
          >
            <path
              d="M256.88 423.75l-7.1 4.1a.53.53 0 000 1l5.62 4a.75.75 0 01.1 1.16 14 14 0 00-2 2.78 1.76 1.76 0 01-1.28.85l-9.45.6a1 1 0 00-.89.94v5.27a1 1 0 00.89.94l9.45.6a1.76 1.76 0 011.28.85 13.68 13.68 0 002 2.78.75.75 0 01-.1 1.16l-5.62 4a.53.53 0 000 1l7.09 4.1a2 2 0 001.57.07l7.19-3.33a2.56 2.56 0 011.64-.1 43.8 43.8 0 005.59 1.33 1.37 1.37 0 011 1l.9 4.73a1.11 1.11 0 001.05.87h10.43a1.13 1.13 0 001-.87l.9-4.73a1.35 1.35 0 011-1 43.4 43.4 0 005.59-1.33 2.56 2.56 0 011.64.1l7.19 3.33a2 2 0 001.57-.07l7.09-4.1a.53.53 0 000-1l-5.62-4a.75.75 0 01-.1-1.16 13.68 13.68 0 002-2.78 1.76 1.76 0 011.5-.84l9.45-.6a1 1 0 00.89-.94v-5.27a1 1 0 00-.89-.94l-9.45-.6a1.76 1.76 0 01-1.28-.85 13.68 13.68 0 00-2-2.78.75.75 0 01.1-1.16l5.62-4a.53.53 0 000-1l-7.09-4.1a2 2 0 00-1.57-.07L296.5 427a2.56 2.56 0 01-1.64.1 42.15 42.15 0 00-5.59-1.32 1.36 1.36 0 01-1-1l-.9-4.74a1.13 1.13 0 00-1.06-.87h-10.45a1.13 1.13 0 00-1.06.87l-.89 4.74a1.39 1.39 0 01-1 1 41.79 41.79 0 00-5.59 1.32 2.56 2.56 0 01-1.64-.1l-7.19-3.33a2 2 0 00-1.61.08zm36.17 11.15c6.62 3.82 6.62 10 0 13.83s-17.35 3.83-24 0-6.62-10 0-13.83 17.38-3.82 24 0z"
              style={{
                transformOrigin: "281.11px 441.81px",
              }}
              id="prefix__elhq5v24n2umi"
              className="prefix__animable"
              fill="#fff"
            />
            <path
              d="M286.29 464.81h-10.43a1.46 1.46 0 01-1.4-1.15l-.9-4.74a1 1 0 00-.75-.73 42.1 42.1 0 01-5.63-1.34 2.27 2.27 0 00-1.39.08l-7.2 3.33a2.21 2.21 0 01-1.88-.08l-7.1-4.1a.92.92 0 01-.5-.74.94.94 0 01.42-.8l5.63-4a.41.41 0 00.05-.64 15 15 0 01-2.06-2.85 1.39 1.39 0 00-1-.67l-9.46-.6a1.31 1.31 0 01-1.21-1.29v-5.27a1.31 1.31 0 011.21-1.29l9.46-.6a1.41 1.41 0 001-.66 14.73 14.73 0 012.06-2.86.48.48 0 00.13-.35.43.43 0 00-.18-.28l-5.63-4.05a.94.94 0 01-.42-.79.92.92 0 01.5-.75l7.1-4.1a2.25 2.25 0 011.88-.08l7.2 3.33a2.27 2.27 0 001.39.08 42.1 42.1 0 015.63-1.34 1 1 0 00.75-.73l.9-4.74a1.47 1.47 0 011.4-1.15h10.43a1.47 1.47 0 011.39 1.15l.9 4.74a1 1 0 00.75.73 42.1 42.1 0 015.63 1.34 2.35 2.35 0 001.39-.08l7.19-3.33a2.23 2.23 0 011.89.08l7.1 4.1a.92.92 0 01.5.74.94.94 0 01-.42.8l-5.61 4.01a.43.43 0 00-.18.29.47.47 0 00.13.34 15 15 0 012.06 2.85 1.39 1.39 0 001 .67l9.46.6a1.31 1.31 0 011.21 1.29v5.27a1.31 1.31 0 01-1.21 1.29l-9.46.6a1.39 1.39 0 00-1 .67 14.55 14.55 0 01-2.06 2.85.41.41 0 00.05.64l5.63 4a.94.94 0 01.42.8.92.92 0 01-.5.74l-7.09 4.1a2.29 2.29 0 01-1.9.08l-7.19-3.33a2.35 2.35 0 00-1.39-.08 42.1 42.1 0 01-5.63 1.34 1 1 0 00-.75.73l-.9 4.74a1.46 1.46 0 01-1.41 1.19zm-19.67-8.73a2.65 2.65 0 01.77.11 42.55 42.55 0 005.53 1.31 1.72 1.72 0 011.33 1.29l.9 4.74a.76.76 0 00.71.59h10.43a.75.75 0 00.7-.59l.9-4.74a1.72 1.72 0 011.33-1.29 42.55 42.55 0 005.53-1.31 2.94 2.94 0 011.9.11l7.19 3.33a1.6 1.6 0 001.25-.05l7.09-4.1c.1-.05.16-.12.16-.18s0-.13-.14-.2l-5.62-4a1.08 1.08 0 01-.47-.78 1.15 1.15 0 01.31-.89 14 14 0 002-2.72 2.1 2.1 0 011.56-1l9.45-.59a.61.61 0 00.56-.6v-5.27a.61.61 0 00-.56-.59l-9.45-.6a2.1 2.1 0 01-1.56-1 13.72 13.72 0 00-2-2.72 1.15 1.15 0 01-.31-.89 1.08 1.08 0 01.47-.78l5.62-4c.09-.07.14-.14.14-.2s-.06-.12-.16-.18l-7.09-4.1a1.6 1.6 0 00-1.25-.05l-7.19 3.33a2.94 2.94 0 01-1.9.11 43.83 43.83 0 00-5.53-1.31 1.72 1.72 0 01-1.33-1.29l-.9-4.74a.75.75 0 00-.7-.58h-10.43a.75.75 0 00-.71.58l-.9 4.74a1.72 1.72 0 01-1.33 1.29 44.24 44.24 0 00-5.53 1.31 2.94 2.94 0 01-1.9-.11L258.3 424a1.6 1.6 0 00-1.25.05l-.17-.3.17.3-7.09 4.1c-.1.06-.16.12-.16.18s0 .13.14.2l5.62 4a1.08 1.08 0 01.47.78 1.15 1.15 0 01-.31.89 13.72 13.72 0 00-2 2.72 2.1 2.1 0 01-1.56 1l-9.45.59a.62.62 0 00-.56.6v5.27a.62.62 0 00.56.6l9.45.59a2.1 2.1 0 011.56 1 13.72 13.72 0 002 2.72 1.15 1.15 0 01.31.89 1.08 1.08 0 01-.47.78l-5.62 4.05a.26.26 0 00-.14.19c0 .06.06.13.16.18l7.09 4.1a1.6 1.6 0 001.25.05l7.19-3.33a2.88 2.88 0 011.13-.12zm14.45-4.14a24.93 24.93 0 01-12.16-2.9c-3.31-1.92-5.14-4.48-5.14-7.23s1.83-5.3 5.14-7.21c6.71-3.87 17.61-3.87 24.32 0 3.31 1.91 5.14 4.47 5.14 7.22s-1.83 5.3-5.14 7.22a24.93 24.93 0 01-12.16 2.9zm0-19.56a24.15 24.15 0 00-11.81 2.82c-3.09 1.78-4.79 4.13-4.79 6.61s1.7 4.84 4.79 6.62c6.51 3.76 17.11 3.76 23.62 0 3.09-1.78 4.79-4.13 4.79-6.61s-1.7-4.84-4.79-6.62a24.15 24.15 0 00-11.81-2.82z"
              style={{
                transformOrigin: "281.08px 441.835px",
              }}
              id="prefix__ell00nvrjih9"
              className="prefix__animable"
              fill="#fff"
            />
          </g>
        </g>
        <g id="prefix__freepik--shadow--inject-93">
          <path
            d="M347.09 441.25l-1-1.86c-.95-.08-1.89-.2-2.8-.36l-3.19 2.12a5.25 5.25 0 01-2.87.83 5 5 0 01-1.83-.34l-4.93-2a3.68 3.68 0 01-1.33-6l.67-.72-5.23.21a4.54 4.54 0 01-4.24-3.1l-.85-2.73a3.93 3.93 0 013.11-5.08l2.88-.49-1.06-.53a3.65 3.65 0 01-.71-6.18l3.14-2.62a5.22 5.22 0 013.28-1.14 4.69 4.69 0 011.42.21l4.67 1.46h.07c.49-.21 1-.41 1.52-.6l-.11-.95a4.09 4.09 0 013.62-4.55l6.15-.64h.45a4.72 4.72 0 014.12 2.49l.95 1.86c.95.08 1.89.21 2.81.36l3.19-2.12a5.24 5.24 0 012.87-.82 4.8 4.8 0 011.83.34l4.93 2a3.68 3.68 0 011.33 6l-.67.72 5.23-.21a4.55 4.55 0 014.24 3.11l.85 2.72a3.93 3.93 0 01-3.11 5.08l-2.88.49 1.06.54a3.65 3.65 0 01.71 6.18l-3.14 2.61a5.17 5.17 0 01-3.29 1.14 4.67 4.67 0 01-1.41-.21l-4.63-1.47h-.07c-.49.21-1 .42-1.52.6l.11 1a4.07 4.07 0 01-3.62 4.54l-6.16.64a3.17 3.17 0 01-.44 0 4.72 4.72 0 01-4.12-2.53zm-5.26-17.86c-.42.35-1.11 1-1 1.71s1 1.78 3.16 2.64a15 15 0 005.58 1c3.13 0 6.1-.85 7.75-2.22.42-.35 1.11-1 1-1.71s-1-1.79-3.16-2.65a15.18 15.18 0 00-5.57-1c-3.14 0-6.11.84-7.76 2.23z"
            style={{
              transformOrigin: "349.545px 424.989px",
            }}
            className="prefix__animable"
            id="prefix__elrdryuy1kifd"
            opacity={0.15}
          />
        </g>
        <path
          d="M337.49 410.54a3.39 3.39 0 01-2 .13l-4.79-1.5a2.25 2.25 0 00-1.88.37l-3.14 2.62a.74.74 0 00-.31.58v5.05a.71.71 0 00.44.63l1.7.85-4.36.75a.91.91 0 00-.78.94V426a1.1 1.1 0 000 .31l.86 2.72a1.49 1.49 0 001.42 1l5.62-.22a2.54 2.54 0 011.36.42l-.29.3a.84.84 0 00-.24.55v5.07a.7.7 0 00.51.65l4.92 2a2.37 2.37 0 001.93-.2l3.31-2.2a3.14 3.14 0 012-.4c1.05.18 2.11.31 3.19.4a2.15 2.15 0 011.59 1l1.23 2.39a1.69 1.69 0 001.58.86l6.16-.64a1.07 1.07 0 001-1v-3.43a1.29 1.29 0 01.63-.45 25.18 25.18 0 002.57-.94 3.39 3.39 0 012-.14l4.79 1.5a2.18 2.18 0 001.88-.37l3.14-2.61a.74.74 0 00.31-.57v-5.09a.7.7 0 00-.44-.61l-1.7-.86 4.36-.74a.92.92 0 00.79-.89v-5.11a1.34 1.34 0 000-.34l-.85-2.72a1.52 1.52 0 00-1.43-1l-5.62.23a2.73 2.73 0 01-1.36-.42l.29-.31a.78.78 0 00.24-.55v-5.05a.72.72 0 00-.51-.63l-4.92-2a2.3 2.3 0 00-1.93.2l-3.31 2.2a3.14 3.14 0 01-2 .39c-1-.18-2.11-.31-3.19-.39a2.17 2.17 0 01-1.59-1l-1.23-2.39a1.7 1.7 0 00-1.58-.86l-6.16.64a1.07 1.07 0 00-.95 1.2l.28 2.34a1.34 1.34 0 01-.92 1.39 25.21 25.21 0 00-2.62.91zm21.75 13.14c-3.7 3.08-11 3.84-16.37 1.71a9.12 9.12 0 01-4.21-3.06 7.25 7.25 0 011.25-1.32c3.7-3.09 11-3.85 16.37-1.71a9.11 9.11 0 014.2 3 7 7 0 01-1.24 1.38z"
          style={{
            transformOrigin: "349.61px 422.355px",
          }}
          id="prefix__el7ukdenbxlj9"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elzkncfmicooc">
          <path
            d="M337.49 410.54a3.39 3.39 0 01-2 .13l-4.79-1.5a2.25 2.25 0 00-1.88.37l-3.14 2.62a.74.74 0 00-.31.58v5.05a.71.71 0 00.44.63l1.7.85-4.36.75a.91.91 0 00-.78.94V426a1.1 1.1 0 000 .31l.86 2.72a1.49 1.49 0 001.42 1l5.62-.22a2.54 2.54 0 011.36.42l-.29.3a.84.84 0 00-.24.55v5.07a.7.7 0 00.51.65l4.92 2a2.37 2.37 0 001.93-.2l3.31-2.2a3.14 3.14 0 012-.4c1.05.18 2.11.31 3.19.4a2.15 2.15 0 011.59 1l1.23 2.39a1.69 1.69 0 001.58.86l6.16-.64a1.07 1.07 0 001-1v-3.43a1.29 1.29 0 01.63-.45 25.18 25.18 0 002.57-.94 3.39 3.39 0 012-.14l4.79 1.5a2.18 2.18 0 001.88-.37l3.14-2.61a.74.74 0 00.31-.57v-5.09a.7.7 0 00-.44-.61l-1.7-.86 4.36-.74a.92.92 0 00.79-.89v-5.11a1.34 1.34 0 000-.34l-.85-2.72a1.52 1.52 0 00-1.43-1l-5.62.23a2.73 2.73 0 01-1.36-.42l.29-.31a.78.78 0 00.24-.55v-5.05a.72.72 0 00-.51-.63l-4.92-2a2.3 2.3 0 00-1.93.2l-3.31 2.2a3.14 3.14 0 01-2 .39c-1-.18-2.11-.31-3.19-.39a2.17 2.17 0 01-1.59-1l-1.23-2.39a1.7 1.7 0 00-1.58-.86l-6.16.64a1.07 1.07 0 00-.95 1.2l.28 2.34a1.34 1.34 0 01-.92 1.39 25.21 25.21 0 00-2.62.91zm21.75 13.14c-3.7 3.08-11 3.84-16.37 1.71a9.12 9.12 0 01-4.21-3.06 7.25 7.25 0 011.25-1.32c3.7-3.09 11-3.85 16.37-1.71a9.11 9.11 0 014.2 3 7 7 0 01-1.24 1.38z"
            style={{
              transformOrigin: "349.61px 422.355px",
            }}
            className="prefix__animable"
            id="prefix__elo7jazi03318"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <g id="prefix__elxs74734wyf">
          <path
            d="M369 422.83a1.06 1.06 0 00.45 1.45l2.25 1.14 4.36-.75a.92.92 0 00.79-.89v-5a.91.91 0 01-.79.83l-5.36.92a1.82 1.82 0 00-1.3 1.25 9.15 9.15 0 01-.4 1.05zm-.92-14.29a.79.79 0 01-.24.55l-2.24 2.37a1 1 0 00.14 1.44 12.25 12.25 0 011.35 1.2 1.89 1.89 0 00.46.36l.29-.31a.79.79 0 00.24-.55z"
            style={{
              transformOrigin: "371.104px 416.98px",
            }}
            className="prefix__animable"
            id="prefix__elwwfq8b6g0y"
            opacity={0.1}
          />
        </g>
        <g id="prefix__elkdn33tqfsph">
          <path
            d="M356.28 414.23c4.6 1.85 6.22 5.24 4.19 8.11a9.09 9.09 0 00-4.19-3c-5.34-2.14-12.66-1.38-16.37 1.71a6.85 6.85 0 00-1.24 1.32c-1.43-2-1.1-4.45 1.24-6.39 3.7-3.13 11.03-3.89 16.37-1.75z"
            style={{
              transformOrigin: "349.573px 417.694px",
            }}
            className="prefix__animable"
            id="prefix__elha5x31v5ozf"
            opacity={0.1}
          />
        </g>
        <path
          d="M348 436.83a1.92 1.92 0 01.53.58l1.23 2.39a1.62 1.62 0 00.9.76v-5.07a1.68 1.68 0 01-.9-.75l-1.24-2.4a1.85 1.85 0 00-.51-.59zm-16.91-.68a.69.69 0 00.5.65l4.93 2a2.33 2.33 0 001.29.05v-5.07a2.24 2.24 0 01-1.29-.05l-4.92-2a.71.71 0 01-.51-.66zm32.66-2.15l4.73 1.48a2.14 2.14 0 001.2 0v-5.06a2.1 2.1 0 01-1.19 0l-4.73-1.42zm-41.43-8a.84.84 0 00.05.31l.84 2.73a1.52 1.52 0 001.43 1l5.62-.22a2.23 2.23 0 01.88.18v-5.07a2.23 2.23 0 00-.88-.18l-5.63.23a1.52 1.52 0 01-1.42-1l-.85-2.72a1.87 1.87 0 01-.05-.3zm3-8.2a.73.73 0 00.44.63l1.71.85 1-.16a1.84 1.84 0 001.31-1.27 8.23 8.23 0 01.41-1.06c0-.09.06-.17.09-.27a1.36 1.36 0 000-.2 1 1 0 00-.06-.39.87.87 0 00-.27-.41.71.71 0 00-.23-.18l-4-2a1 1 0 01-.25-.17.51.51 0 01-.17-.26.58.58 0 010-.18z"
          style={{
            transformOrigin: "345.995px 426.645px",
          }}
          id="prefix__el95xtb3djm0h"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__el2k79brkuzpl">
          <path
            d="M348 436.83a1.92 1.92 0 01.53.58l1.23 2.39a1.62 1.62 0 00.9.76v-5.07a1.68 1.68 0 01-.9-.75l-1.24-2.4a1.85 1.85 0 00-.51-.59zm-16.91-.68a.69.69 0 00.5.65l4.93 2a2.33 2.33 0 001.29.05v-5.07a2.24 2.24 0 01-1.29-.05l-4.92-2a.71.71 0 01-.51-.66zm32.66-2.15l4.73 1.48a2.14 2.14 0 001.2 0v-5.06a2.1 2.1 0 01-1.19 0l-4.73-1.42zm-41.43-8a.84.84 0 00.05.31l.84 2.73a1.52 1.52 0 001.43 1l5.62-.22a2.23 2.23 0 01.88.18v-5.07a2.23 2.23 0 00-.88-.18l-5.63.23a1.52 1.52 0 01-1.42-1l-.85-2.72a1.87 1.87 0 01-.05-.3zm3-8.2a.73.73 0 00.44.63l1.71.85 1-.16a1.84 1.84 0 001.31-1.27 8.23 8.23 0 01.41-1.06c0-.09.06-.17.09-.27a1.36 1.36 0 000-.2 1 1 0 00-.06-.39.87.87 0 00-.27-.41.71.71 0 00-.23-.18l-4-2a1 1 0 01-.25-.17.51.51 0 01-.17-.26.58.58 0 010-.18z"
            style={{
              transformOrigin: "345.995px 426.645px",
            }}
            className="prefix__animable"
            id="prefix__elmyhdxj2eotd"
            fill="#fff"
            opacity={0.7}
          />
        </g>
        <path
          d="M328.78 409.54l-3.14 2.62a.66.66 0 00.13 1.19l4 2a1.07 1.07 0 01.45 1.45 8.65 8.65 0 00-.4 1.07 1.82 1.82 0 01-1.31 1.25l-5.35.92a.93.93 0 00-.75 1.22l.85 2.73a1.52 1.52 0 001.42 1l5.63-.23a2.73 2.73 0 011.82.77 11.3 11.3 0 001.35 1.2 1 1 0 01.13 1.44l-2.23 2.38a.7.7 0 00.27 1.21l4.92 2a2.37 2.37 0 001.93-.2l3.31-2.2a3.19 3.19 0 012-.4 30.54 30.54 0 003.19.4 2.14 2.14 0 011.59 1l1.22 2.38a1.71 1.71 0 001.59.86l6.16-.64a1.06 1.06 0 00.95-1.2l-.28-2.34a1.34 1.34 0 01.92-1.39 25.18 25.18 0 002.57-.94 3.29 3.29 0 012-.13l4.79 1.5a2.24 2.24 0 001.89-.38l3.14-2.61a.66.66 0 00-.13-1.19l-3.95-2a1.08 1.08 0 01-.46-1.45 7.24 7.24 0 00.41-1.06 1.82 1.82 0 011.3-1.25l5.36-.92a.93.93 0 00.75-1.23l-.85-2.72a1.52 1.52 0 00-1.43-1l-5.62.23a2.72 2.72 0 01-1.82-.78 14.56 14.56 0 00-1.35-1.2 1 1 0 01-.14-1.44l2.24-2.37a.7.7 0 00-.27-1.21l-4.92-2a2.3 2.3 0 00-1.93.2l-3.31 2.2a3.14 3.14 0 01-2 .39c-1-.18-2.11-.31-3.19-.39a2.17 2.17 0 01-1.59-1l-1.23-2.39a1.7 1.7 0 00-1.58-.86l-6.16.64a1.07 1.07 0 00-.95 1.2l.28 2.34a1.34 1.34 0 01-.92 1.39 25.21 25.21 0 00-2.57 1 3.39 3.39 0 01-2 .13l-4.79-1.5a2.25 2.25 0 00-1.94.31zm27.5 4.69c5.33 2.14 6.66 6.37 3 9.45s-11 3.84-16.37 1.71-6.66-6.37-3-9.45 11.03-3.85 16.37-1.71z"
          style={{
            transformOrigin: "349.617px 419.815px",
          }}
          id="prefix__elgystuxcp17"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elcqjjavukw5j">
          <g
            style={{
              transformOrigin: "349.58px 419.733px",
            }}
            className="prefix__animable"
            id="prefix__elpj0lu5g3et"
            opacity={0.55}
          >
            <path
              d="M328.78 409.54l-3.14 2.62a.66.66 0 00.13 1.19l4 2a1.07 1.07 0 01.45 1.45 8.65 8.65 0 00-.4 1.07 1.82 1.82 0 01-1.31 1.25l-5.35.92a.93.93 0 00-.75 1.22l.85 2.73a1.52 1.52 0 001.42 1l5.63-.23a2.73 2.73 0 011.82.77 11.3 11.3 0 001.35 1.2 1 1 0 01.13 1.44l-2.23 2.38a.7.7 0 00.27 1.21l4.92 2a2.37 2.37 0 001.93-.2l3.31-2.2a3.19 3.19 0 012-.4 30.54 30.54 0 003.19.4 2.14 2.14 0 011.59 1l1.22 2.38a1.71 1.71 0 001.59.86l6.16-.64a1.06 1.06 0 00.95-1.2l-.28-2.34a1.34 1.34 0 01.92-1.39 25.18 25.18 0 002.57-.94 3.29 3.29 0 012-.13l4.79 1.5a2.24 2.24 0 001.89-.38l3.14-2.61a.66.66 0 00-.13-1.19l-3.95-2a1.08 1.08 0 01-.46-1.45 7.24 7.24 0 00.41-1.06 1.82 1.82 0 011.3-1.25l5.36-.92a.93.93 0 00.75-1.23l-.85-2.72a1.52 1.52 0 00-1.43-1l-5.62.23a2.72 2.72 0 01-1.82-.78 14.56 14.56 0 00-1.35-1.2 1 1 0 01-.14-1.44l2.24-2.37a.7.7 0 00-.27-1.21l-4.92-2a2.3 2.3 0 00-1.93.2l-3.31 2.2a3.14 3.14 0 01-2 .39c-1-.18-2.11-.31-3.19-.39a2.17 2.17 0 01-1.59-1l-1.23-2.39a1.7 1.7 0 00-1.58-.86l-6.16.64a1.07 1.07 0 00-.95 1.2l.28 2.34a1.34 1.34 0 01-.92 1.39 25.21 25.21 0 00-2.57 1 3.39 3.39 0 01-2 .13l-4.79-1.5a2.25 2.25 0 00-1.94.31zm27.5 4.69c5.33 2.14 6.66 6.37 3 9.45s-11 3.84-16.37 1.71-6.66-6.37-3-9.45 11.03-3.85 16.37-1.71z"
              style={{
                transformOrigin: "349.617px 419.815px",
              }}
              id="prefix__el1olit633zum"
              className="prefix__animable"
              fill="#fff"
            />
            <path
              d="M351.21 436a2.17 2.17 0 01-1.84-1.1l-1.22-2.39a1.76 1.76 0 00-1.25-.8c-1.09-.09-2.17-.22-3.23-.4a2.66 2.66 0 00-1.67.33l-3.31 2.2a2.8 2.8 0 01-2.33.24l-4.92-2a1.19 1.19 0 01-.76-.82 1.17 1.17 0 01.34-1.07l2.23-2.38a.51.51 0 00.15-.39.58.58 0 00-.24-.42 13.93 13.93 0 01-1.39-1.24 2.42 2.42 0 00-1.49-.64l-5.63.23a1.93 1.93 0 01-1.85-1.31l-.85-2.72a1.37 1.37 0 011.09-1.78l5.35-.91a1.43 1.43 0 001-1 8.5 8.5 0 01.42-1.12.64.64 0 00-.25-.88l-3.95-2a1.14 1.14 0 01-.68-.88 1.18 1.18 0 01.46-1l3.14-2.62a2.68 2.68 0 012.29-.45l4.79 1.5a3 3 0 001.74-.12 26.65 26.65 0 012.61-1 .92.92 0 00.62-.93l-.28-2.33a1.48 1.48 0 011.34-1.68l6.15-.65a2.15 2.15 0 012 1.1l1.22 2.38a1.77 1.77 0 001.25.81c1.09.08 2.17.22 3.23.4a2.74 2.74 0 001.67-.33l3.31-2.2a2.77 2.77 0 012.33-.24l4.92 2a1.12 1.12 0 01.42 1.9l-2.23 2.38a.46.46 0 00-.15.39.56.56 0 00.24.41 15.3 15.3 0 011.39 1.24 2.38 2.38 0 001.49.65l5.63-.23a1.9 1.9 0 011.85 1.3l.85 2.72a1.4 1.4 0 01-.13 1.15 1.37 1.37 0 01-1 .63l-5.35.92a1.42 1.42 0 00-1 .95 8.62 8.62 0 01-.42 1.13.63.63 0 00.25.88l3.95 2a1.17 1.17 0 01.68.89 1.18 1.18 0 01-.46 1l-3.14 2.61a2.69 2.69 0 01-2.29.46l-4.79-1.5a3 3 0 00-1.74.11 26.66 26.66 0 01-2.61 1 .89.89 0 00-.62.92l.28 2.34a1.51 1.51 0 01-1.34 1.68l-6.15.64zm-7.85-5.58a2.25 2.25 0 01.46 0q1.55.27 3.15.39a2.56 2.56 0 011.94 1.27l1.23 2.39a1.29 1.29 0 001.16.63l6.15-.65a.59.59 0 00.44-.24.63.63 0 00.14-.48l-.29-2.33a1.79 1.79 0 011.22-1.86 23.6 23.6 0 002.53-.93 3.74 3.74 0 012.33-.14l4.79 1.5a1.81 1.81 0 001.48-.3l3.15-2.61a.36.36 0 00.15-.26c0-.08-.08-.16-.21-.22l-3.95-2a1.51 1.51 0 01-.65-2 5.84 5.84 0 00.38-1 2.27 2.27 0 011.65-1.56l5.35-.91a.52.52 0 00.42-.68l-.86-2.72a1.06 1.06 0 00-1-.7l-5.62.23a3.1 3.1 0 01-2.15-.91 13.39 13.39 0 00-1.3-1.16 1.41 1.41 0 01-.57-1 1.34 1.34 0 01.38-1.05l2.23-2.38a.35.35 0 00.13-.3.37.37 0 00-.24-.21l-4.92-2a1.9 1.9 0 00-1.53.16l-3.31 2.19a3.59 3.59 0 01-2.3.47q-1.54-.27-3.15-.39a2.59 2.59 0 01-1.94-1.27l-1.23-2.31a1.28 1.28 0 00-1.16-.63l-6.15.64a.63.63 0 00-.44.24.65.65 0 00-.14.48l.29 2.34a1.77 1.77 0 01-1.23 1.85c-.87.28-1.72.59-2.52.93a3.74 3.74 0 01-2.33.15l-4.79-1.5a1.84 1.84 0 00-1.49.29l-3.14 2.62c-.1.09-.16.18-.15.26s.08.15.21.21l3.95 2a1.49 1.49 0 01.65 2 7 7 0 00-.39 1 2.21 2.21 0 01-1.64 1.55l-5.35.92a.53.53 0 00-.38.24.55.55 0 000 .44l.85 2.72a1.08 1.08 0 001 .7l5.62-.23a3.13 3.13 0 012.15.9 13.46 13.46 0 001.3 1.17 1.41 1.41 0 01.57 1 1.39 1.39 0 01-.38 1.05l-2.24 2.38a.36.36 0 00-.12.29.38.38 0 00.24.22l4.92 2a1.9 1.9 0 001.53-.16l3.31-2.2a3.59 3.59 0 011.81-.5zm6.18-3.43a18.69 18.69 0 01-6.83-1.23c-3-1.21-4.93-3.14-5.27-5.3a5.26 5.26 0 012.2-4.88c3.8-3.17 11.34-4 16.8-1.78 3 1.21 4.93 3.14 5.27 5.3a5.26 5.26 0 01-2.2 4.88c-2.35 2.02-6.13 3.02-9.97 3.02zm0-13.57c-3.63 0-7.18 1-9.39 2.82a4.39 4.39 0 00-1.9 4.08c.29 1.86 2 3.55 4.74 4.64 5.2 2.08 12.35 1.34 15.93-1.64a4.43 4.43 0 001.9-4.09c-.29-1.85-2-3.54-4.74-4.63a17.82 17.82 0 00-6.5-1.15z"
              style={{
                transformOrigin: "349.58px 419.733px",
              }}
              id="prefix__eln071sc5ofj"
              className="prefix__animable"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--character-3--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "264.11px 210.419px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--Character--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "264.11px 210.419px",
        }}
      >
        <g
          id="prefix__freepik--Bottom--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "290.67px 259.283px",
          }}
        >
          <path
            d="M264.3 327.44c1.46-.9 2.82-1.95 4.29-2.84a23.07 23.07 0 004.15-3.09 25.52 25.52 0 005-8 29.44 29.44 0 001.39-4.86c.81-4.24.74-23.63.89-29.86l16.47 7.94a181.45 181.45 0 00-3.75 20.54c-.26 5.11 2.63 11.37-2.07 14.74-.93.66-2 1.11-3 1.7-3.17 1.91-5.34 5.18-8.21 7.54a19.4 19.4 0 01-7.28 3.66 11.37 11.37 0 01-3.32.69 27.57 27.57 0 01-4.32-.61 7.14 7.14 0 01-2.52-.91 3.1 3.1 0 01-1.46-2.21 3.32 3.32 0 011.06-2.57 10.91 10.91 0 012.31-1.62z"
            style={{
              transformOrigin: "278.524px 307.195px",
            }}
            id="prefix__elc6ilzpj20iw"
            className="prefix__animable"
            fill="#b16668"
          />
          <path
            d="M294.44 319.12a5.75 5.75 0 01-.14 3.42c-.65.88-1.67 1.56-4.13 2.91a10.2 10.2 0 00-4.38 4.56 20.05 20.05 0 01-3.81 4.62c-2.77 2.51-6.86 3.89-13.57 3.53-4.2-.22-7.63-2-8.53-3.19a3.22 3.22 0 01-.57-2.54z"
            style={{
              transformOrigin: "276.942px 328.668px",
            }}
            id="prefix__elx3et560bns"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M293.53 308.35c0-.65-.58-1.35-.81-1.11a5.8 5.8 0 01-.6 2.55 10.81 10.81 0 01-6.32 4s.23-.73-1.32-1.32-5.5-2.11-6.32-1.69-1.68 4.67-4.37 8.41a22.43 22.43 0 01-9.11 7.12c-2.39 1-5.12 3-5.11 6.19 2.44 3.52 9 3.93 13.05 3.61 7.12-.58 10.35-5.1 12.34-7.81s2.66-3.12 5.91-5.42c1.42-1 2.9-1.72 3.57-3.77.71-5.01-.96-5.11-.91-10.76z"
            style={{
              transformOrigin: "277.093px 321.695px",
            }}
            id="prefix__eletki3lfoevc"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M276.5 335.31c.39-2.65-.82-6-4.87-8.18s-5.8-1.67-7.21-1.14-6.27 3-5 6.66c.46 1.83 8.97 5.69 17.08 2.66z"
            style={{
              transformOrigin: "267.89px 330.981px",
            }}
            id="prefix__elrngrk02x2wf"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M285.8 313.8a1.57 1.57 0 00-1.06.36 3.44 3.44 0 00-.65 1l-1 2c-.69 1.33-1.39 2.65-2.15 3.93a38.21 38.21 0 01-2.45 3.7 19.71 19.71 0 01-3 3.26 13.52 13.52 0 003.41-2.91 26.47 26.47 0 002.63-3.68 42.57 42.57 0 002.07-4c.31-.69.6-1.4.85-2.1a4 4 0 01.46-1 1.68 1.68 0 01.89-.56z"
            style={{
              transformOrigin: "280.645px 320.924px",
            }}
            id="prefix__el3n82jz4wyvn"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M277.45 327.46c-1.26-1.35-6.87-3.95-8.75-3.35l-.45.29a2.23 2.23 0 011.05-1.06c.88-.51 5.76.49 8.89 3.35.16.5-.32 1.15-.74.77z"
            style={{
              transformOrigin: "273.236px 325.393px",
            }}
            id="prefix__elhrnvqp0saxh"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M279.78 324.6c-1.25-1.35-6.14-3.58-8-3l-.37.35a1.81 1.81 0 011-1.12c.88-.51 5 .12 8.17 3 .11.5-.38 1.17-.8.77z"
            style={{
              transformOrigin: "276.003px 322.696px",
            }}
            id="prefix__el1mjfgbw84ev"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M281.4 321.59c-1.29-1.32-5.6-3.27-7.47-2.62l-.28.41a2 2 0 01.72-1.1c.83-.6 4.55-.26 7.75 2.51.18.49-.29 1.21-.72.8z"
            style={{
              transformOrigin: "277.905px 319.87px",
            }}
            id="prefix__elsflf61mb8fo"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M283 319c-1.29-1.32-5.6-3.27-7.47-2.61l-.23.44a1.74 1.74 0 01.67-1.13c.83-.61 4.55-.27 7.75 2.51.14.47-.33 1.13-.72.79z"
            style={{
              transformOrigin: "279.523px 317.268px",
            }}
            id="prefix__elm48xkk4h4r"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M298.84 306.1c1.31-2.35 3-4.11 3.92-5.83a16.36 16.36 0 002.16-6.51 52.63 52.63 0 00.22-7.46c-.06-4.9-6.4-13.52-12.44-20.81l16.46-4c2.84 6.89 5.87 15.34 6.41 16.2l.14.2c1 1.43 2.81 1.88 4.17 4.1a4.32 4.32 0 01-.25 4.63c-.13.19-.26.38-.39.6a21.75 21.75 0 00-2.3 4.25c-.69 1.88-.37 4.42-.33 7.13a7.18 7.18 0 01-2.32 6c-1.43 1.46-6.29 4.69-9.85 5.12-5.65.75-6.9-1.26-5.6-3.62z"
            style={{
              transformOrigin: "306.568px 285.685px",
            }}
            id="prefix__elq6ruv4jncs"
            className="prefix__animable"
            fill="#b16668"
          />
          <path
            d="M320.76 283.17a4.24 4.24 0 011.37 2.59 13.71 13.71 0 01-2.28 4.8c-1.42 2-2 2.88-1.89 4.76a16.91 16.91 0 01-.87 7.34 15.36 15.36 0 01-9.15 9c-4.5 1.81-7.67.77-8.83.2s-.93-2.4-.93-2.4z"
            style={{
              transformOrigin: "310.146px 297.924px",
            }}
            id="prefix__elk74qlmpgb7"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M315.53 277.59a2.72 2.72 0 01.66 2.3c-.43 2.61-3.91 5.15-4.87 5.8a3.52 3.52 0 00-1.74-.85c-1.59-.45-4.41 0-4.89.63s.4 5.14-.32 9.09a17.72 17.72 0 01-4.1 8.52c-1.51 1.71-3.91 3.95-1.89 7.12 1.44.91 8.22 1.86 13.69-2.77 4.85-4.12 4.81-9.77 4.71-12.69s1.12-4.32 2.81-7.41c.74-1.34 1.4-2.32 1.17-4.16a12.21 12.21 0 00-5.23-5.58z"
            style={{
              transformOrigin: "309.206px 294.271px",
            }}
            id="prefix__elvvlhn5jsha8"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M312.07 307.43a6.47 6.47 0 00-4.46-5.7c-4.24-1.13-6.67-.33-7.86.73-1 .88-5 4.71-1.57 7.8 1.07 1.19 7.43 2.96 13.89-2.83z"
            style={{
              transformOrigin: "304.443px 306.33px",
            }}
            id="prefix__elfit387ucxn"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M311.32 285.69a1.42 1.42 0 00-.7.71 3.2 3.2 0 00-.15 1c0 .66 0 1.29-.07 2 0 1.29-.11 2.59-.22 3.87a37.56 37.56 0 01-.55 3.83 18.1 18.1 0 01-1.15 3.71 12.24 12.24 0 001.59-3.6 22.52 22.52 0 00.7-3.89 34.41 34.41 0 00.13-3.93c0-.65-.06-1.31-.11-1.95a3.7 3.7 0 010-.94 1.56 1.56 0 01.53-.81z"
            style={{
              transformOrigin: "309.9px 293.25px",
            }}
            id="prefix__el56l6h0po185"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M309.49 300c-1.29-1-5.62-1.55-6.8-.49l-.22.41a2.17 2.17 0 01.43-1.32c.5-.73 3.85-1.64 6.9.45.26.46.09 1.23-.31.95z"
            style={{
              transformOrigin: "306.197px 298.91px",
            }}
            id="prefix__elfova43px7a5"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M310.26 296.74c-1.23-1.12-5.05-1.46-6.29-.48l-.11.37a1.3 1.3 0 01.29-1.25c.53-.69 4.09-1.34 6.48.43.23.47.02 1.19-.37.93z"
            style={{
              transformOrigin: "307.266px 295.733px",
            }}
            id="prefix__elhwgggmokwp"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M310.76 293.64c-1.22-1.12-5-1.53-6.2-.54v.43a1.06 1.06 0 01.14-1.25c.53-.7 4.08-1.34 6.48.43.19.46-.02 1.22-.42.93z"
            style={{
              transformOrigin: "307.834px 292.636px",
            }}
            id="prefix__elrb8plib2n7k"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M310.91 290.34c-1.26-1.07-5.05-1.3-6.26-.26v.37a1.11 1.11 0 010-1.16c.46-.75 4.15-1.57 6.61.11.24.46.06 1.22-.35.94z"
            style={{
              transformOrigin: "307.927px 289.433px",
            }}
            id="prefix__elvevkpmh9gg8"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M271.57 180.47s-1.39 8.1-1.54 25.44c-.12 14.52-2 24.19 3.47 33.61 4.93 8.4 26.41 37.89 28.66 40.82 0 0 7.83-.36 11.87-6.71 0 0-3.91-11.82-8.11-21.65s-8.29-19.43-8.29-19.43l12-44.42z"
            style={{
              transformOrigin: "291.826px 230.405px",
            }}
            id="prefix__elytglei4v0zm"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M311 275.84l.77-.23c-2.88-9.67-14.92-37.15-20.18-42.47l-.56.56c5.07 5.13 17.19 32.78 19.97 42.14z"
            id="prefix__elap8fzjaiec"
            className="prefix__animable"
            style={{
              transformOrigin: "301.4px 254.49px",
            }}
          />
          <path
            d="M312.06 267.91c-1.47 3-9.38 8.78-13.22 7.94l4.16 5.75c3.54.31 9.33-3.33 11.46-7.09z"
            style={{
              transformOrigin: "306.65px 274.764px",
            }}
            id="prefix__elvl4amphd73p"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M273.29 184.16l36.35 4-12 44.42 6.12 14.34c-.29.85-1.23 5.75-1.31 6.05-.29 1 2.07 5.13 0 17.33-.39 2.35-1.35 5.74-1.92 7.92-4.1-5.61-12.87-17.52-19.38-27.08-.46-.83-1.19-2.3-1.19-2.3s-1.26-7.93-.41-13.65c.72-4.82 3.74-30.57 3.74-30.57a19.77 19.77 0 01-5.22-5.13 13 13 0 01-2.34-5.54 82 82 0 01-2.44-9.79z"
            style={{
              transformOrigin: "291.465px 231.19px",
            }}
            id="prefix__el7wbw4ocbj4v"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M315.37 180.35c0 6.62.32 9 .09 13.79-.29 6-1.85 12-3.69 18.75s-10.66 36.89-11.35 39.28c.69 5.23 1.44 9.87-.67 21.17-3.05 16.32-6.58 30.7-6.58 30.7s-8.48 1.95-13.61-1.32c0 0-.23-46.84.44-57.55.58-9.31 6-41.93 6-41.93a26.86 26.86 0 01-14.42-22.77z"
            style={{
              transformOrigin: "293.562px 242.483px",
            }}
            id="prefix__el614fkbermq"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M296.4 248.73c.5-1.85 1.91-6.42 3.7-12.21 3-9.73 7.19-25.24 8.61-31.18 1.7-7.09 1.9-22 1.9-22.11h.8c0 .15-.2 15.11-1.92 22.28-1.42 6-5.45 21-8.63 31.23-1.71 5.56-3.2 10.35-3.69 12.19a19.54 19.54 0 00-.23 6.66 66.67 66.67 0 01-.69 16.93c-1.24 7.9-4.57 23.48-6.43 32l-.83.05c1.85-8.45 5.22-24.21 6.47-32.17a66.71 66.71 0 00.69-16.75 20.23 20.23 0 01.25-6.92z"
            style={{
              transformOrigin: "300.2px 243.9px",
            }}
            id="prefix__eld5hqkvblp5u"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M294.78 297.19c-3.07 1.49-12.66 1.68-15.26-1.42v7.12c2.69 2.48 9.71 3 13.81 1.26z"
            style={{
              transformOrigin: "287.15px 300.471px",
            }}
            id="prefix__elzs466kq2i9"
            className="prefix__animable"
            fill="#455a64"
          />
        </g>
        <g
          id="prefix__freepik--Top--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "262.482px 138.841px",
          }}
        >
          <g
            id="prefix__freepik--Chest--inject-93"
            className="prefix__animable"
            style={{
              transformOrigin: "262.482px 138.841px",
            }}
          >
            <path
              d="M244.9 142.9c4.44.45 22.19.88 22.19.88l10.21-13.91c-8.23-3.39-8.24-1.44-20.08-1.61s-13.47-.09-13.47-.09c-5.34-4.91-11.21-9.39-16.48-14.69-2.07-2.42-1.61-5.91-3-8.64-.9-2.39-2.9-4.25-3.56-6.78-.71-2.89-3-.51-2.81 1.42a23.2 23.2 0 00.89 4.4c0 .21.07.47-.1.61a2 2 0 01-1.3-.24 32.7 32.7 0 01-6.67-7.07c-1.06-1.34-4.28-3.13-4.49-.28a4.36 4.36 0 01.13 1.9 5.48 5.48 0 00-.27 1.25c0 .87.88 1.56.86 2.44 0 .41-.23.8-.24 1.22 0 .68.49 1.26.67 1.92.24.87-.12 1.83.15 2.7a16.8 16.8 0 001.73 3 25.71 25.71 0 004 4.9c2.09 2.12 5.17 3 7.1 5.31 3.84 4.77 11.72 15.59 14.91 18.54 2.43 2.32 5.19 2.37 9.63 2.82z"
              style={{
                transformOrigin: "241.695px 119.58px",
              }}
              id="prefix__elvxgb8ls37fk"
              className="prefix__animable"
              fill="#b16668"
            />
            <path
              d="M219.05 106.46c-.27 4.16.44 7.3 2.73 10.36-3.46-1.82-5.29-5.76-2.73-10.36z"
              style={{
                transformOrigin: "219.815px 111.64px",
              }}
              id="prefix__elprfg10devo"
              className="prefix__animable"
              fill="#9a4a4d"
            />
            <path
              d="M281 126.65c-5.29-.83-11.8-.33-17.4 0l-19 1.19a31.74 31.74 0 011.13 7.59c.19 5.45-1.88 7.58-1.88 7.58s4.36.64 9.57.88c7.36.34 15.75.44 15.75.44z"
              style={{
                transformOrigin: "262.425px 135.263px",
              }}
              id="prefix__elgj34ej5fbpf"
              className="prefix__animable"
              fill="#455a64"
            />
            <path
              d="M247.66 127.4a16.4 16.4 0 00-4.4.32l.49.45s.77 1.41.91 5.29c.15 4.11-.1 8.41-1.45 9.27l-1.31-.15s-.62 1 1.6 1.2 4.89.59 5.72-.06c.59-.46 2.06-2.52 1.86-7.74-.24-6.34-1.88-8.32-3.42-8.58z"
              style={{
                transformOrigin: "246.459px 135.724px",
              }}
              id="prefix__elpwtq17tojiq"
              className="prefix__animable"
              fill="#37474f"
            />
            <path
              d="M268.72 153.4c-1.07-12.1-.3-24 11.19-26.59 2.22-.5 9.69-.56 15.48.9 8.79 2.24 12.25 3 16.07 4.57 0 0 3.3 5.59 3.43 27 .08 13.91.43 17.08 1.07 31.54-9.54 4.71-39.56 5.69-45.41-4.46.56-8.68-.38-16.57-1.83-32.96z"
              style={{
                transformOrigin: "292.165px 160.365px",
              }}
              id="prefix__eljz2kc8edq8f"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M307.76 131.38c-1.32 1.58-3.51 6.58-4.85 13.69-2.14 11.44-3.73 23.78-3.73 23.78-1.12.31-17.34 10.36-24 11-2.34.13-4.54-1-6.88-1a16.63 16.63 0 01-3.31 0 22.24 22.24 0 00-2.29-.36c-2.1-.1-1.25 1.94-.09 2.94 1.32 1.14 4.1 1 5 1.68s-1.17 1.31-1.94 1.49a27.58 27.58 0 01-9 .32 6.89 6.89 0 00-4.53.7c-.43.23-.68 1.27-.17 1.51 1 .43 1.43.69 1.43.69a2.22 2.22 0 002 2.14c.45.11-.1 1.17 1.59 2.08.55.29.74 1 1.2 1.41a11.73 11.73 0 006.16 1.59 23.45 23.45 0 009.53-1.6c1.92-.7 3.48-2.18 5.42-2.89 7.84-3.23 19.94-6.49 23.86-8 8.07-3 8.42-3 10.45-11.88 2.45-10.71 3.81-19.32 4.61-23.76.95-5.91-2-14.06-10.46-15.53z"
              style={{
                transformOrigin: "285.038px 163.22px",
              }}
              id="prefix__elpuf34d11dt"
              className="prefix__animable"
              fill="#b16668"
            />
            <path
              d="M307.53 130.85c4.72 1.07 5.79 1.93 8 4.25s4 5.47 3.11 13.28-4.64 22.35-4.64 22.35-8.08-2.34-14.45-4.42c0 0 1.29-10.4 1.84-14.39.71-5.24 1.83-16.23 6.14-21.07z"
              style={{
                transformOrigin: "309.212px 150.79px",
              }}
              id="prefix__el29wdqwuy08h"
              className="prefix__animable"
              fill="#455a64"
            />
            <path
              d="M299.33 168.15a17 17 0 017.43.95c4.57 1.47 6.08 4.36 6.08 4.36l-.31 1.15s.78.34 1.44-1.66 1.42-4.23.95-5.77-3.42-5-7.48-5.85-7.2.27-7.69 1.36-1.52 5.75-.56 6.16z"
              style={{
                transformOrigin: "306.93px 167.831px",
              }}
              id="prefix__elcptx0tfi7ro"
              className="prefix__animable"
              fill="#37474f"
            />
            <g
              id="prefix__freepik--Head--inject-93"
              className="prefix__animable"
              style={{
                transformOrigin: "285.133px 108.526px",
              }}
            >
              <path
                d="M297.15 120.27c.4-3.7 3.8-7.74 5.24-11s2.19-5.62 1.83-8.5c-.21-1.7-1.44-4-2.74-4.37a8 8 0 00-6.48-9.6 27.67 27.67 0 01-3.57-.76c-1.41-.49-1.79-1.58-3-2.46-2-1.5-5.25-1.34-6.32 1.2-1.38-1.57-3.1-1.42-5.07-.79a3.4 3.4 0 00-2.37 4 3.6 3.6 0 00-5.25 2.3c-.11 1.17.2 2.13-.49 3.21s-2.4 1.31-2.95.39c-.17 1.66.55 2.88 2.33 2.68a3.73 3.73 0 00-.27 3.17 3.44 3.44 0 003.22 2.16 5.25 5.25 0 003.17 4.22c2.78 1.12 5.8 1.35 8.74 1.77l3.5.51c.21 0 1.25 0 1.39.19z"
                style={{
                  transformOrigin: "285.133px 101.446px",
                }}
                id="prefix__el49k4xee4flk"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M301.29 115.26a3.54 3.54 0 01-4.32.14l.38 12.47c-.26 3-6.17 6.88-11.26 6.54-5.85-.38-5.51-3.24-3.12-6.38l-.09-3.34a36.19 36.19 0 01-4.55.12c-2.89-.22-5.2-2.41-6.21-5.47a32.35 32.35 0 01-1.12-12.29 10.91 10.91 0 000-3 14.21 14.21 0 01.5-6.52c3-2.74 10.24-4.06 17.31-.34-.54 4.1 1.24 7.21 4.28 8.57-.07 1.1 0 3.88 1.76 3.71 1.3-.11 1.28-1.74 2.52-3.26s4.32-2.09 5.66 0a7 7 0 01-1.74 9.05z"
                style={{
                  transformOrigin: "287.407px 114.665px",
                }}
                id="prefix__elmvfwmmivbye"
                className="prefix__animable"
                fill="#b16668"
              />
              <path
                d="M282.88 124.69c4.52-.82 7.76-1.49 9.93-4.93a29.12 29.12 0 002.4-5.57 22.08 22.08 0 01-1.53 6.88c-1 2.18-3.66 4.3-10.75 5.36z"
                style={{
                  transformOrigin: "289.045px 120.31px",
                }}
                id="prefix__elgydwklqr7qw"
                className="prefix__animable"
                fill="#9a4a4d"
              />
              <path
                d="M283.45 107.05a1.3 1.3 0 001.38 1.23 1.32 1.32 0 001.18-1.43 1.28 1.28 0 10-2.56.2z"
                style={{
                  transformOrigin: "284.73px 106.972px",
                }}
                id="prefix__ela38gvhkvth9"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M283.53 102.83l3 1a1.65 1.65 0 00-1-2 1.54 1.54 0 00-2 1z"
                style={{
                  transformOrigin: "285.062px 102.784px",
                }}
                id="prefix__el6nk9dz6ksv4"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M272.59 104l3-1a1.53 1.53 0 00-2-1 1.67 1.67 0 00-1 2z"
                style={{
                  transformOrigin: "274.06px 102.952px",
                }}
                id="prefix__elacev6xbrrgl"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                d="M273.25 107a1.28 1.28 0 101.18-1.43 1.32 1.32 0 00-1.18 1.43z"
                style={{
                  transformOrigin: "274.523px 106.847px",
                }}
                id="prefix__ellzlzwzb4rim"
                className="prefix__animable"
                fill="#263238"
              />
              <path
                style={{
                  transformOrigin: "277.4px 109.345px",
                }}
                id="prefix__elt1jv4trajyl"
                className="prefix__animable"
                fill="#9a4a4d"
                d="M274.93 112.07l4.94 1.9-.01-9.25-4.93 7.35z"
              />
              <path
                d="M284.73 115l-5.21 1.74a2.7 2.7 0 003.43 1.83 2.89 2.89 0 001.78-3.57z"
                style={{
                  transformOrigin: "282.189px 116.851px",
                }}
                id="prefix__ellqsakrnul78"
                className="prefix__animable"
                fill="#9a4a4d"
              />
              <path
                d="M284.18 115.89a3 3 0 01.66-.06 2.85 2.85 0 01-1.89 2.69 2.94 2.94 0 01-.87.12 2.51 2.51 0 012.1-2.75z"
                style={{
                  transformOrigin: "283.453px 117.235px",
                }}
                id="prefix__elbcs6bze5ns"
                className="prefix__animable"
                fill="#f28f8f"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--character-2--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "175.917px 261.041px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--character--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "175.917px 261.041px",
        }}
      >
        <g
          id="prefix__freepik--bottom--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "152.239px 302.612px",
          }}
        >
          <path
            d="M172.71 352.06c.25-4.35 4-39.57 4-39.57l-18.14 9.24c1.08 19.58 2.53 28.9 2.54 32.27a4 4 0 01.06.7c-.27 3.84 4.16 6.25 7.54 9.08a67.83 67.83 0 009.22 6.7c2.51 1.43 7.77 1.94 8.54.41-4.11-3.47-8.89-7.28-12.08-11.13-1.5-1.83-1.91-3.65-1.68-7.7z"
            style={{
              transformOrigin: "172.52px 342.156px",
            }}
            id="prefix__ely4m95eqgnv"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M193.61 375.58a3.12 3.12 0 01-.9 3.26c-1.48 1-5.72 2.59-11.1 1.52s-8.19-2.88-10.23-4.76-4.9-4.54-7.32-5.23a15.34 15.34 0 01-5.32-2.53c-.68-.73-.36-3.68-.36-3.68z"
            style={{
              transformOrigin: "176.029px 372.438px",
            }}
            id="prefix__elkrfjkx1p1n"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M161.08 353s-.37-.07-.56.61-.59 3.16-1.05 4.47a23 23 0 00-1.07 7.15c.19 1.54 3.83 2.87 6.14 3.91a30.38 30.38 0 017.34 5.17 23.25 23.25 0 0011.12 4.85c5.39.49 9-.63 10.2-2.38 1.51-2.17.56-3.56-5.44-6.75-1.14-.6-5.09-3.22-6.43-4.16a20.63 20.63 0 01-8-9.95 2.29 2.29 0 00-.8-1.3 2.21 2.21 0 00-1.2-.19 15.69 15.69 0 00-3.7.46c-.86.31-2.08.66-2.13 1.67a3.36 3.36 0 00.15 1c.06.21.1.49-.1.6s-.42-.05-.57-.2a15.77 15.77 0 01-1.53-2 5.5 5.5 0 00-.91-1 9.67 9.67 0 01-1-.73 2 2 0 01-.46-1.23z"
            style={{
              transformOrigin: "176.117px 366.137px",
            }}
            id="prefix__eln8oz67imge"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M188.76 370.56c-7.85-.09-10.65 4.29-11.2 7.08a19.11 19.11 0 005.47 1.52c5.39.49 9.21-.61 10.42-2.36 1.42-2.05.7-3.8-4.69-6.24z"
            style={{
              transformOrigin: "185.822px 374.918px",
            }}
            id="prefix__elpgloxdhjzil"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M177 369.75a.43.43 0 01-.24-.1.36.36 0 010-.52 9.48 9.48 0 017.26-2.09.36.36 0 01.31.42.38.38 0 01-.45.29 8.79 8.79 0 00-6.57 1.88.39.39 0 01-.31.12z"
            style={{
              transformOrigin: "180.492px 368.356px",
            }}
            id="prefix__elbpvk4dgguqk"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M173.81 367.64a.4.4 0 01-.23-.1.35.35 0 010-.51 9.46 9.46 0 017.26-2.1.36.36 0 11-.13.71 8.73 8.73 0 00-6.57 1.89.4.4 0 01-.33.11z"
            style={{
              transformOrigin: "177.303px 366.247px",
            }}
            id="prefix__elu0wpfnzhv6"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M170.85 365.29a.4.4 0 01-.23-.1.36.36 0 010-.52 9.51 9.51 0 017.26-2.09.36.36 0 01.31.42.38.38 0 01-.44.29 8.75 8.75 0 00-6.57 1.89.44.44 0 01-.33.11z"
            style={{
              transformOrigin: "174.352px 363.897px",
            }}
            id="prefix__elo3qtn5tnq"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M168 362.94a.37.37 0 01-.23-.1.35.35 0 010-.51c1.63-1.67 5.1-2.59 7.91-2.08a.36.36 0 01.31.42.37.37 0 01-.44.29c-2.53-.46-5.77.38-7.21 1.86a.38.38 0 01-.34.12z"
            style={{
              transformOrigin: "171.828px 361.527px",
            }}
            id="prefix__elvw138aocnni"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M137.71 330.16l-16.32-3.27c-1.76 10.37-2.25 22.14-3.85 31.88-.3 1.83-2.8 14.15-2.8 18 0 5.83 7.24 6.36 8.27 3.06s4.09-17.85 4.4-19.34c1.14-6.22 5.17-16.15 9-27 .14-.49 1.12-2.81 1.3-3.33z"
            style={{
              transformOrigin: "126.225px 354.374px",
            }}
            id="prefix__el9kpihbo3zg"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M125.22 382.7c-.49 3.34-1.24 5.52-2.67 7.38s-3.86 2.27-6.22 1.49S111 389 110.58 386a17.48 17.48 0 01.69-8z"
            style={{
              transformOrigin: "117.807px 384.972px",
            }}
            id="prefix__el5ndc6mofuvt"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M117.73 357.57c-1 0-1.68 4.47-2.64 8.94-1 4.78-2.73 6.65-3.62 10.57-1 4.48-.93 6.52.51 9.41s7.16 6.08 10.43 2.41c2.66-3 3.07-6.53 3.24-11.08a97.8 97.8 0 011.3-11.43c.49-3.38 1.58-6.73.75-7.18-.11.49-.23 1.11-.34 1.6s-.35 2.2-.9 2.17a6.14 6.14 0 01.1-1.28 1.46 1.46 0 00-.18-1.12 1.92 1.92 0 00-1.06-.56c-1-.27-3-.53-4-.7-.49-.08-1-.15-1.48-.18a4.16 4.16 0 00-1.27.06.89.89 0 00-.58.41 1.5 1.5 0 00-.1.52 3.3 3.3 0 01-.2.92c-.05.13-.16.28-.3.24a.28.28 0 01-.14-.29c.05-.55.15-.94.23-1.57 0-.3.13-.69.16-1s.04-.57.09-.86z"
            style={{
              transformOrigin: "119.4px 374.06px",
            }}
            id="prefix__elzm5gvdgnl8"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M111 379.68c-.41 2.8-.41 4.74.72 7 1.45 2.88 7.64 6.13 10.91 2.46a12.35 12.35 0 002.62-6.44c-1.53-3.17-11.25-5.35-14.25-3.02z"
            style={{
              transformOrigin: "118px 384.741px",
            }}
            id="prefix__elfvtndop7p37"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M123.1 377.56a.31.31 0 01-.12-.05 15.35 15.35 0 00-8.49-1.57.36.36 0 01-.42-.3.35.35 0 01.32-.39 15.92 15.92 0 019 1.66.35.35 0 01.14.48.4.4 0 01-.43.17z"
            style={{
              transformOrigin: "118.821px 376.363px",
            }}
            id="prefix__el7tf33qcjsw3"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M115 372.59a.4.4 0 01-.29-.26.35.35 0 01.27-.43c4.57-1 8.78 1.48 9 1.59a.35.35 0 01.12.48.39.39 0 01-.51.1s-4.14-2.46-8.39-1.49a.29.29 0 01-.2.01z"
            style={{
              transformOrigin: "119.424px 372.894px",
            }}
            id="prefix__elr1xnqf4rnm"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M115.55 369.43a.4.4 0 01-.29-.26.36.36 0 01.26-.43 12 12 0 019.15 1.58.33.33 0 01.08.48.39.39 0 01-.52.08 11.39 11.39 0 00-8.51-1.46z"
            style={{
              transformOrigin: "120.035px 369.69px",
            }}
            id="prefix__el5veil5o0mao"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M116.16 365.87a.35.35 0 010-.68c4.72-1.22 9 1.56 9.2 1.68a.33.33 0 01.09.48.38.38 0 01-.51.09s-4.19-2.71-8.58-1.57z"
            style={{
              transformOrigin: "120.705px 366.191px",
            }}
            id="prefix__elv0meu98tslt"
            className="prefix__animable"
            fill="#ebebeb"
          />
          <path
            d="M143.65 213.28a7.86 7.86 0 01-1.92 3.67c-4.89 5.75-8.81 11.35-10.11 22.43-3.23 27.41-5 55.94-5 55.94-.39 2.41-2.81 6.53-4.83 19-1.76 10.91-2.77 26-2.77 26s7.66 4.43 14.75 2.38c3.5-8.69 11.17-31.39 15.18-43.1 3.64-10.63 6.81-26.45 6.81-26.45l2.85 22.55a64.48 64.48 0 00-1 14.33c.24 7.43 1.8 28.8 1.8 28.8s8.56 3.34 14.81-.29c0 0 4.64-36.6 5.47-45.49 1.54-16.55 4.34-50.45 1.06-72a46.88 46.88 0 01.1-4.95c-6.25 4.3-29.85 3.01-37.2-2.82z"
            style={{
              transformOrigin: "150.648px 278.261px",
            }}
            id="prefix__ele7yk24qflnn"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M152.18 221.85a.34.34 0 00-.41.2 88.24 88.24 0 00-1.1 3.47c-1.2 3.94-2.07 6.79-5.38 9.64a10.63 10.63 0 01-7.91 2.38c2-8.11 5.37-14.43 10.26-19.47a.31.31 0 000-.44.35.35 0 00-.46 0c-5 5.18-8.45 11.69-10.48 20a79.24 79.24 0 00-1.7 10.27c-1.61 15.44-4 38.76-4.81 44.88a44.55 44.55 0 01-2.63 9.59c-1.08 3-2.29 6.49-3.52 11.25-2.65 10.29-3.23 27.52-3.24 27.69a.32.32 0 00.3.32.3.3 0 00.33-.29c0-.18.59-17.34 3.22-27.57 1.22-4.74 2.43-8.17 3.5-11.2a45.31 45.31 0 002.67-9.72c.76-6.12 3.2-29.44 4.81-44.88a75.41 75.41 0 011.64-9.83h.33a11.16 11.16 0 008.16-2.56c3.44-3 4.33-5.89 5.56-9.93.33-1.09.67-2.21 1.1-3.45a.32.32 0 00-.24-.35z"
            style={{
              transformOrigin: "136.611px 279.588px",
            }}
            id="prefix__elyyxv2vvzvqs"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M119.25 336.94c2.16 2.41 11.9 4.42 15.67 2.8l-2 5.75s-2.46 1.25-7.65.33c-6-1.07-6.5-3.06-6.5-3.06z"
            style={{
              transformOrigin: "126.845px 341.549px",
            }}
            id="prefix__el0voimpitirh"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M159.12 335.6c3 1.3 11.89 1.42 15.47-.4l-.57 4.91s-2.07 1.67-7.34 1.78-7.26-1.5-7.26-1.5z"
            style={{
              transformOrigin: "166.855px 338.548px",
            }}
            id="prefix__elvjbfr04k7ep"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M155.75 273.16l5.74-26.85a17.24 17.24 0 0014.28-5.43s-.36 6.81-11.78 9l-6.24 24.66.85 21.2z"
            style={{
              transformOrigin: "165.76px 268.31px",
            }}
            id="prefix__elrakn30bphc"
            className="prefix__animable"
            fill="#263238"
          />
        </g>
        <g
          id="prefix__freepik--top--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "187.04px 184.249px",
          }}
        >
          <path
            d="M171.19 173.35c8.9 0 11 1.61 22 6l12.43 4.91c5-5.23 10.6-10.07 15.52-15.69 1.92-2.54 1.24-6 2.45-8.81.74-2.44 2.63-4.43 3.12-7 .53-2.93 3-.69 2.89 1.24a23.33 23.33 0 01-.6 4.45c0 .21 0 .47.14.6a2 2 0 001.27-.32 32.59 32.59 0 006.22-7.47c1-1.41 4.07-3.39 4.47-.56a4.2 4.2 0 000 1.9 5.36 5.36 0 01.34 1.23c0 .87-.77 1.62-.7 2.48 0 .42.27.79.31 1.21.07.68-.41 1.29-.54 2-.19.89.23 1.82 0 2.7a16.49 16.49 0 01-1.51 3.08 25.8 25.8 0 01-3.64 5.13c-2 2.25-5 3.33-6.76 5.75-3.53 5-10.84 16.18-13.71 19.44-4 4.49-5.62 4.5-15.86 1.93-9.14-2.3-23.67-7.46-23.67-7.46z"
            style={{
              transformOrigin: "206.315px 174.272px",
            }}
            id="prefix__elx9yq26eda6b"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M228.91 161c.53 4.13 0 7.32-2.08 10.51 3.34-1.98 4.92-6.06 2.08-10.51z"
            style={{
              transformOrigin: "228.606px 166.255px",
            }}
            id="prefix__elgqwlyd5uca"
            className="prefix__animable"
            fill="#f0997a"
          />
          <path
            d="M171.11 173a32.07 32.07 0 0114 2.6c5.21 2.08 19.24 8.1 19.24 8.1a17.16 17.16 0 00-3.23 6.66 14.7 14.7 0 00.15 8s-5.59-1.35-10.56-2.92l-15.86-5z"
            style={{
              transformOrigin: "187.73px 185.667px",
            }}
            id="prefix__el9srf7r4ewjh"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M205.62 184.23s-1.79.7-2.81 4.68-.89 8.26 0 9.57l1.21.26s-.21.94-2.32.63-5-1.25-5.45-1.83-1.52-4.34-.36-9.44 4.09-6.48 5.62-6.14a29.18 29.18 0 014.5 1.84"
            style={{
              transformOrigin: "200.689px 190.672px",
            }}
            id="prefix__eldgodr27rsqt"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M181.52 203.34c.1 4.06-.55 15-.55 15 1.08 10.19 1.19 15.77 1.19 15.77-18.27 9.05-46.23 1.45-49.52-2.61 2-8.85 7.84-16.8 7-21.59l-2.35-17.74s6.69-5.2 6.38-18.31a47.56 47.56 0 0110.94-2 100.43 100.43 0 0116.5 1.14c2.84 1.67 8.71 7.13 12 12.78s4 12.05-1.59 17.56z"
            style={{
              transformOrigin: "159.147px 205.106px",
            }}
            id="prefix__el03j9dywquvqv"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elowrqf5dbhq">
            <path
              d="M167.72 202.45s-4.82 4-10.53 2.19a9.67 9.67 0 01-6.7-6.72s-.39 6.48 6.81 8.44a9.34 9.34 0 0010.42-3.91z"
              style={{
                transformOrigin: "159.103px 202.321px",
              }}
              className="prefix__animable"
              id="prefix__elljdxx1qtq1"
              opacity={0.1}
            />
          </g>
          <path
            d="M180.79 139.22c2.35 4.47 1.59 9-2.61 11.42 0 .67-1.63 12.51 2.35 14.77-1.29 3.59-5.78 6.42-18.79 5.43s-16.88-2.63-18.21-6.48-1.69-26.74 7.46-27.16c7.83-12.29 25.3-6.52 29.8 2.02z"
            style={{
              transformOrigin: "162.465px 150.588px",
            }}
            id="prefix__elaakuohtyx0b"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M171.93 137.55c3 1.12 6.13 4.68 6.6 17.73.34 9.3-2.16 11-3.57 11.93-2.27 1.56-4.63 1.5-7.61 1.21l-.33 5.51s6 8.66 3 12.55a25.12 25.12 0 01-12.22-6.35A21.07 21.07 0 01153 174l.56-11.91s-1.63 1.73-4.72-.56c-2.56-1.89-3.6-5.27-1.83-7.24a4.33 4.33 0 016.81.87s3.31 0 3.65-6.17c0 0 .32-1.5 3.26-2.12 9.16-1.98 11.41-7.72 11.2-9.32z"
            style={{
              transformOrigin: "162.345px 162.015px",
            }}
            id="prefix__elqwtjt403kl"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M167.35 168.42c-4.67-.45-9.8-2.5-10.95-4.86a5.16 5.16 0 002.93 4.14 54.79 54.79 0 007.91 2.51z"
            style={{
              transformOrigin: "161.875px 166.885px",
            }}
            id="prefix__elx8xvf801uob"
            className="prefix__animable"
            fill="#f0997a"
          />
          <path
            d="M166.52 159.47l4.4 1.21a2.26 2.26 0 01-2.78 1.58 2.29 2.29 0 01-1.62-2.79z"
            style={{
              transformOrigin: "168.683px 160.906px",
            }}
            id="prefix__el56o4r6ii9b3"
            className="prefix__animable"
            fill="#b16668"
          />
          <path
            d="M166.87 160.38h-.39a2.28 2.28 0 003.06 1.79 3 3 0 00-2.67-1.79z"
            style={{
              transformOrigin: "168.01px 161.349px",
            }}
            id="prefix__elhsbz4vag1v4"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            d="M166.15 151.78a1.37 1.37 0 01-1.18 1.51 1.31 1.31 0 01-1.54-1.08 1.38 1.38 0 011.18-1.51 1.31 1.31 0 011.54 1.08z"
            id="prefix__els0852qa5jl"
            className="prefix__animable"
            style={{
              transformOrigin: "164.79px 151.995px",
            }}
          />
          <path
            d="M176.56 148.16l-2.87-1.1a1.54 1.54 0 012.87 1.1z"
            id="prefix__elkoiqipl4q7"
            className="prefix__animable"
            style={{
              transformOrigin: "175.16px 147.161px",
            }}
          />
          <path
            d="M165.23 147.79l-2.76 1.38a1.53 1.53 0 01.69-2.08 1.46 1.46 0 012.07.7z"
            id="prefix__el7qix07vxdko"
            className="prefix__animable"
            style={{
              transformOrigin: "163.764px 148.034px",
            }}
          />
          <path
            d="M176.53 150.84a1.36 1.36 0 01-1.17 1.51 1.32 1.32 0 01-1.54-1.08 1.36 1.36 0 011.17-1.51 1.31 1.31 0 011.54 1.08z"
            id="prefix__elxpzlkxbdpod"
            className="prefix__animable"
            style={{
              transformOrigin: "175.175px 151.054px",
            }}
          />
          <path
            d="M169.73 150.14l1.55 7.49 4.2-1.78c-1.62-1.85-4.18-5.22-5.75-5.71z"
            style={{
              transformOrigin: "172.605px 153.885px",
            }}
            id="prefix__el7bav9e2fhlv"
            className="prefix__animable"
            fill="#f0997a"
          />
          <path
            d="M143.57 175c1.59 1.3 4.35 5.19 7.47 11.72 4.52 9.44 12.2 21.62 12.2 21.62 1.17.09 19.09 6.29 25.78 5.59 2.33-.31 4.28-1.8 6.57-2.27a16.63 16.63 0 003.24-.66 21.79 21.79 0 012.18-.78c2.05-.51 1.6 1.66.66 2.86-1.08 1.37-3.84 1.79-4.55 2.59s1.4 1.07 2.18 1.1a27.11 27.11 0 008.9-1.41 7 7 0 014.59-.18c.46.15.91 1.13.45 1.45-.85.61-1.27 1-1.27 1a2.22 2.22 0 01-1.53 2.48c-.43.19.32 1.12-1.17 2.34-.48.39-.53 1.12-.91 1.62a11.8 11.8 0 01-5.74 2.73 23.48 23.48 0 01-9.62.2c-2-.32-3.83-1.48-5.87-1.81-8.32-1.67-20.9-2-25-2.69-8.5-1.43-7.67-1.75-13-9.19-5.71-8-11.51-17.69-13.14-21.89-2.2-5.59-2.36-13.76 7.58-16.42z"
            style={{
              transformOrigin: "174.1px 201.202px",
            }}
            id="prefix__el3giu66om86y"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M143.66 173.88c-4.91 1.59-7.18 4.26-8.45 7.21s-1.65 7.33 1.95 14.33S150 215.27 150 215.27s6.75-5 12-9.18c0 0-5.29-9.13-7.32-12.61s-5.68-14.58-11.02-19.6z"
            style={{
              transformOrigin: "148.155px 194.575px",
            }}
            id="prefix__elr5phj1vo8u"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M163.24 208.34s-3.24-.09-7 2.89-4.38 6-4.38 6l.86 1.24s-.57.49-1.89-1.16-2.81-3.47-2.91-5.08 1.46-5.88 5-8.09 6.83-2.26 7.67-1.41 3.44 4.86 2.68 5.57z"
            style={{
              transformOrigin: "155.661px 210.379px",
            }}
            id="prefix__elz9hwhke6yq"
            className="prefix__animable"
            fill="#37474f"
          />
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--character-4--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "312.073px 307.356px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--character--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "312.073px 307.356px",
        }}
      >
        <g
          id="prefix__freepik--bottom--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "337.478px 348.459px",
          }}
        >
          <path
            d="M331.34 355.57c1.45-.28 5.2-.89 6.66-1.67 2.55-1.34 3.05-1.79 5.36-1.66 3.2.17 3.62.92 4.58 3.21s-.15 4.63 2.36 10.17c2 4.48 3.34 8.27 2.28 11.2s-3 5.73-7.57 5.62c-5-.13-6.76-2.9-5.07-4.81a7.08 7.08 0 001.82-3.65c.35-2.93-1.51-6.46-2.54-7-1.55-.84-2.48-.38-5.74.92z"
            style={{
              transformOrigin: "342.146px 367.331px",
            }}
            id="prefix__elupto6vdeu1"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M316.82 310.84c2.07 5.31 9.8 23.62 4.49 35.58-1.83 4.1-4.85 11.77-4.85 11.77l15.85-3c1.28.31 1.94 1.88 2.52 4.24 1.33 5.38-.27 8.26-.27 8.26s-5.74 3.45-17.3 7.72c-11.88 4.38-16.81 3.51-20.84 1s-5.87-6.57-4.35-17.58c2-14.19 12.93-51.39 12.93-51.39"
            style={{
              transformOrigin: "313.449px 342.967px",
            }}
            id="prefix__elm0ydfj74ko"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M316.78 341.23l1.76 11.77c.91-2.25 2-4.78 2.77-6.6 3.5-7.89 1.33-18.54-1.15-26.4l-.68-.4-11.58 7.13c-.24 3.19 2.74 10.44 8.88 14.5z"
            style={{
              transformOrigin: "315.512px 336.3px",
            }}
            id="prefix__elmac5kheqq3e"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M316.46 358.19c-2.84 7.87-4 11.32-5.51 13.12 0 0 3.09-1.27 5.42-7.33 1.59-4.14 2.14-6.17 2.14-6.17z"
            style={{
              transformOrigin: "314.73px 364.56px",
            }}
            id="prefix__elwgn6f1s25jf"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M341.76 374c-.19 1.92.48 4.46 3.53 2.48s.94-6.34.15-8.54-1.62-8.39-2.52-11-2.73-3.92-3.82-3.47l-1.1.45s-.27-1 2.07-1.73 4.08-1.43 5.46-.72 2.59 1.9 3.11 5.31.38 4.89 1.57 7.47 3.88 8 2.69 12.41c-.84 3.14-2.7 6.08-6.25 6.81-4.09.85-7.78.1-8.79-2.09s2.58-4.38 3.9-7.38z"
            style={{
              transformOrigin: "345.44px 367.493px",
            }}
            id="prefix__el06g4x5eeks03"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M361.52 364.93c1.45-.28 5.2-.9 6.66-1.67 2.55-1.34 3.05-1.8 5.36-1.67 3.19.17 3.62.92 4.57 3.22s-.15 4.62 2.37 10.17c2 4.48 3.33 8.26 2.27 11.19s-3 5.74-7.56 5.62c-5-.13-6.76-2.9-5.07-4.8a7.09 7.09 0 001.81-3.65c.36-2.94-1.5-6.47-2.53-7-1.55-.84-2.49-.38-5.75.93z"
            style={{
              transformOrigin: "372.322px 376.681px",
            }}
            id="prefix__elk172h4siwpi"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M365 368.82c-.58-2.37-1.25-3.94-2.52-4.25l-17 1.81s1.95-11.57 2.81-19.41c1.43-13 .81-21.47-1.26-26.77-1.67-4.3-6.42-11.77-6.42-11.77l-1.61-4.67c-7.42 5.59-23.85 7.38-34 3.72-2.27 15.86 6.86 28.35 14.76 32 0 0 1.27 23.94 1.61 33.25.26 7.44 3.5 12.94 6.54 14.43 4.26 2.08 7.65 2 19.53-2.4 11.56-4.27 17.3-7.72 17.3-7.72s1.6-2.84.26-8.22z"
            style={{
              transformOrigin: "335.091px 346.12px",
            }}
            id="prefix__elb2adc8yrrz5"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M345.45 366.38c-1.3 7-2.78 12.49-4.32 14.29 0 0 3-1.14 4.89-7.35a48.12 48.12 0 001.59-7.17z"
            style={{
              transformOrigin: "344.37px 373.41px",
            }}
            id="prefix__el6xie9d8ftrl"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M371.93 383.34c-.18 1.91.49 4.45 3.54 2.48 2.9-1.89 2.46-6.35 1.67-8.54s-3.14-8.4-4-11-2.73-3.92-3.82-3.46l-1.1.45s-.27-1 2.06-1.74 4.09-1.42 5.47-.72 2.59 1.9 3.11 5.32.37 4.88 1.56 7.47 3.89 8 2.7 12.41c-.84 3.13-2.7 6.08-6.25 6.81-4.1.84-7.78.1-8.79-2.09s2.53-4.36 3.85-7.39z"
            style={{
              transformOrigin: "375.659px 376.837px",
            }}
            id="prefix__elsmuq92qjsoi"
            className="prefix__animable"
            fill="#37474f"
          />
        </g>
        <g
          id="prefix__freepik--top--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "297.341px 267.849px",
          }}
        >
          <path
            d="M311.37 263.17c-8.9.19-10.95 1.85-21.87 6.43l-12.33 5.18c-5.13-5.12-10.8-9.85-15.84-15.37-2-2.5-1.37-6-2.63-8.75-.8-2.43-2.73-4.37-3.27-6.93-.6-2.92-3-.63-2.87 1.3a23.31 23.31 0 00.7 4.44.58.58 0 01-.13.6 1.89 1.89 0 01-1.28-.29 32.4 32.4 0 01-6.37-7.34c-1-1.38-4.15-3.3-4.48-.47a4.24 4.24 0 01.05 1.91 5.86 5.86 0 00-.32 1.23c0 .87.81 1.6.76 2.47 0 .42-.26.8-.29 1.21 0 .68.44 1.28.59 2 .2.88-.2 1.83 0 2.7a16.41 16.41 0 001.6 3.11 25.92 25.92 0 003.75 5.05c2 2.21 5 3.23 6.87 5.61 3.64 4.93 11.18 16 14.12 19.15 4.09 4.4 5.72 4.38 15.9 1.59 9.09-2.49 23.51-7.95 23.51-7.95z"
            style={{
              transformOrigin: "276.05px 265.222px",
            }}
            id="prefix__el5pi0jt4pyyv"
            className="prefix__animable"
            fill="#ffa8a7"
          />
          <path
            d="M253.4 252.06c-.44 4.14.14 7.31 2.3 10.46-3.38-1.93-5.04-5.98-2.3-10.46z"
            style={{
              transformOrigin: "253.863px 257.29px",
            }}
            id="prefix__ell6h1tkdox8l"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            d="M311.44 262.85a32.29 32.29 0 00-13.94 2.9c-5.17 2.19-19.07 8.5-19.07 8.5a17.18 17.18 0 013.37 6.59 14.75 14.75 0 010 8s5.55-1.47 10.49-3.14l15.76-5.34z"
            style={{
              transformOrigin: "294.935px 275.843px",
            }}
            id="prefix__elust9nuhd72"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M277.17 274.78s1.81.65 2.9 4.62 1.07 8.23.18 9.56l-1.2.29s.23.94 2.33.58 4.95-1.35 5.41-1.95 1.43-4.37.16-9.43-4.23-6.4-5.75-6a29.66 29.66 0 00-4.46 1.93"
            style={{
              transformOrigin: "282.16px 281.148px",
            }}
            id="prefix__eltjeqc8sdndd"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M304.46 305.24a2.48 2.48 0 01-.95-2.13c.11-3.47-.16-4.41-.72-8.25-6.2-6.13-4.45-11.57-3.6-14.61 2.08-7.45 12.25-17.4 12.25-17.4l4.6-.57c8-.86 10.27-1 14.3 0s6.13 1.54 6.13 1.54c-1.85 5.14 6.34 6.49 7.39 10.15.92 3.19-1.1 13-1.1 13s-2.69 11.2-2.39 15.3a2.66 2.66 0 01-.87 2.12c-.26 1.46-.3 2.69-.55 4.2-19.72 6.47-31.04 1.96-34.49-3.35z"
            style={{
              transformOrigin: "321.199px 286.683px",
            }}
            id="prefix__elb02esq63eug"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M339.5 304.37c-2.92 2-8.05 4.43-16.41 5.05s-16-2-18.63-4.18l-.09 4.41s5.91 5.07 18.91 4.33 17.3-5.55 17.3-5.55z"
            style={{
              transformOrigin: "322.475px 309.212px",
            }}
            id="prefix__el9ct2htl3mx"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M300.45 236c5 9 22.37 4.68 22.31 17.52.46 2.11 2.26 4.33 4.43 2.62a71.79 71.79 0 015.8-9.4c3.8-4.85 4.92-12.54-.7-15.75-.53-4.52-2.35-8.93-11.21-9.39s-11.18 2.8-17.86.17c-4.44-1-4 7.29-1.62 9.05-2.15.48-1.99 3.57-1.15 5.18z"
            style={{
              transformOrigin: "318.004px 239.152px",
            }}
            id="prefix__elrovkippho5m"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M329.58 229a10.35 10.35 0 0114.53 2.19c2.22 3 2.62 7 2.46 10.78a17.51 17.51 0 00.27 5.92 7.53 7.53 0 007.11 5.2c.05.81-.84 1.33-1.63 1.56a9.63 9.63 0 01-7.57-1.06 9.42 9.42 0 007.82 7.19 7 7 0 01-5.52 1.86 12.35 12.35 0 01-10.92-8.64c-1.11-3.82-.26-7.9-.2-11.88a11.35 11.35 0 00-.52-4 5.25 5.25 0 00-2.55-3c-1.19-.55-2.71-.59-3.5-1.62"
            style={{
              transformOrigin: "341.656px 244.816px",
            }}
            id="prefix__eli9jore26cl"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M305.85 231s-3.92 5.39-2.83 16.52c.55 5.63 1.85 9.48 5.46 10.76a15 15 0 006.54.31l.31 4.78c-6.14 5.82 4.17 11.77 12.54-.49l-.13-11.58s2.14 1.69 4.49-.81c2.59-2.77 2.46-6.89.35-8.23-3.1-2-5.2.58-5.89 2.11s-2.9 1.35-2.47-2.14-.15-9.61-3.1-10.49c-3.64-1.04-8.22 7.18-15.27-.74z"
            style={{
              transformOrigin: "318.499px 250.526px",
            }}
            id="prefix__el7dscebb2rft"
            className="prefix__animable"
            fill="#ffa8a7"
          />
          <path
            d="M315.7 249.7l-4.25 1.3a2 2 0 002.59 1.59 2.5 2.5 0 001.66-2.89z"
            style={{
              transformOrigin: "313.602px 251.193px",
            }}
            id="prefix__el0qry9znz2nn"
            className="prefix__animable"
            fill="#b16668"
          />
          <path
            d="M316.21 238.64l3 1.31a1.59 1.59 0 00-.71-2.21 1.79 1.79 0 00-2.29.9z"
            style={{
              transformOrigin: "317.81px 238.78px",
            }}
            id="prefix__elej322q6j71b"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M317.82 242.35a1.27 1.27 0 11-1.36-1.17 1.26 1.26 0 011.36 1.17z"
            style={{
              transformOrigin: "316.554px 242.446px",
            }}
            id="prefix__ellgsuf66809"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M308.56 242.24a1.27 1.27 0 11-1.36-1.17 1.26 1.26 0 011.36 1.17z"
            style={{
              transformOrigin: "307.294px 242.336px",
            }}
            id="prefix__elmis27pogwxq"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M307.81 238.48l-2.9 1.78a1.7 1.7 0 01.6-2.31 1.66 1.66 0 012.3.53z"
            style={{
              transformOrigin: "306.246px 238.976px",
            }}
            id="prefix__elsi9xq4y5pse"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            style={{
              transformOrigin: "309.845px 244.18px",
            }}
            id="prefix__el5x91d5pc7yr"
            className="prefix__animable"
            fill="#f28f8f"
            d="M312.23 240.35l-.47 7.66-4.3-1.21 4.77-6.45z"
          />
          <path
            d="M315 258.62a28 28 0 008.72-3.61 9.37 9.37 0 002.6-3.73s-.32 3.47-2.17 5.08c-2.94 2.56-9 4.36-9 4.36z"
            style={{
              transformOrigin: "320.66px 256px",
            }}
            id="prefix__elasanx1ta3ve"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            d="M315.62 250.94a4.52 4.52 0 00-.51 0 3.28 3.28 0 00-2.33 1.58 2.08 2.08 0 001.26 0 2.4 2.4 0 001.58-1.58z"
            style={{
              transformOrigin: "314.2px 251.775px",
            }}
            id="prefix__elxvgp1iqpdnj"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            d="M336.69 264.23c-1.66 1.21-4.63 4.94-8.11 11.28-5 9.17-13.39 20.9-13.39 20.9-1.17 0-19.36 5.79-26 4.72-2.3-.45-4.17-2-6.42-2.64a16.47 16.47 0 01-3.21-.84 22.34 22.34 0 00-2.13-.91c-2-.62-1.69 1.58-.81 2.83 1 1.43 3.73 2 4.39 2.84s-1.45 1-2.24 1a27.45 27.45 0 01-8.81-1.9 7 7 0 00-4.57-.44c-.47.12-1 1.07-.53 1.42.81.66 1.22 1 1.22 1a2.21 2.21 0 001.39 2.56c.41.22-.38 1.11 1 2.4.46.42.47 1.15.82 1.67a11.79 11.79 0 005.58 3.05 23.58 23.58 0 009.63.79c2-.21 3.9-1.26 6-1.47 8.4-1.21 20.92-1.4 25.09-1.86 8.56-1 7.75-1.32 13.46-8.45 6.15-7.7 12.48-17 14.34-21.13 2.46-5.46 3.08-13.61-6.7-16.82z"
            style={{
              transformOrigin: "304.805px 289.186px",
            }}
            id="prefix__elszl4j2reka"
            className="prefix__animable"
            fill="#ffa8a7"
          />
          <path
            d="M336.47 263.82c5.23 1.86 7.12 3.94 8.23 7s1.24 7.4-2.74 14.19-14 19.1-14 19.1-6.46-5.38-11.46-9.84l8-12.18c2.26-3.4 6.35-13.56 11.97-18.27z"
            style={{
              transformOrigin: "330.936px 283.965px",
            }}
            id="prefix__eld0w6h05vn"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M315.6 295.83a16.86 16.86 0 016.42 3.86c3.6 3.18 4 6.27 4 6.27l-.92 1.2s.54.51 1.94-1.05 3-3.32 3.19-4.91-1.13-6-4.51-8.36-6.7-2.63-7.58-1.84-3.71 4.66-3 5.41z"
            style={{
              transformOrigin: "322.637px 298.92px",
            }}
            id="prefix__elv2ee22z5tb"
            className="prefix__animable"
            fill="#37474f"
          />
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--Flag--inject-93"
      className="prefix__animable prefix__animator-active"
      style={{
        transformOrigin: "177.603px 197.057px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight,1.5s Infinite linear floating",
        animationDelay: "0s,1s",
      }}
    >
      <g
        id="prefix__freepik--flag--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "177.603px 197.057px",
        }}
      >
        <path
          d="M270.16 383L202.08 26.38l2.95-.57 68.2 357.27c.16.84-2.87 1.06-3.07-.08z"
          style={{
            transformOrigin: "237.658px 204.797px",
          }}
          id="prefix__elshbf6zdrp0k"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M206.82 26.14a3.31 3.31 0 11-3.23-3.37 3.3 3.3 0 013.23 3.37z"
          style={{
            transformOrigin: "203.511px 26.079px",
          }}
          id="prefix__el23rldaite46"
          className="prefix__animable"
          fill="#37474f"
        />
        <path
          d="M205.55 20a3.3 3.3 0 01-6.47 1.33c-1-4.6 1.12-11 1.12-11s4.41 5.1 5.35 9.67z"
          style={{
            transformOrigin: "202.214px 17.146px",
          }}
          id="prefix__elsi81vdw37tn"
          className="prefix__animable"
          fill="#37474f"
        />
        <path
          d="M202.63 29.23c-16.25 29.17-48.28 23.7-73.21 27-27 3.53-41.6 15.27-47.45 28.54 7.31-3.53 29.32-5.74 37.23-1.4 0 0-23.79 23-18.23 52.16 5.55-13.87 17.53-25.81 45.24-25.45 24.34.31 56 5.39 68.84-15.76z"
          style={{
            transformOrigin: "148.51px 82.38px",
          }}
          id="prefix__elak363ib4o7c"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elid567qnrklh">
          <path
            d="M189.12 99.31c-20.26 10.69-84.4-6.67-88.12 36.18 5.55-13.87 17.53-25.81 45.24-25.45 24.34.31 56 5.39 68.84-15.76l-12.42-65c4.79 25.56 6.72 59.38-13.54 70.03z"
            style={{
              transformOrigin: "158.04px 82.385px",
            }}
            className="prefix__animable"
            id="prefix__elvm0g83hp6pe"
            opacity={0.1}
          />
        </g>
        <g id="prefix__elvvk61zd3xub">
          <path
            d="M159.46 63.25l5.83 10.49 12-.67a.8.8 0 01.63 1.35l-8.17 8.78 4.34 11.19a.81.81 0 01-1.09 1l-10.9-5.04-9.3 7.58a.8.8 0 01-1.3-.72L153 85.3l-10.09-6.5a.8.8 0 01.28-1.46L154.92 75 158 63.44a.8.8 0 011.46-.19z"
            style={{
              transformOrigin: "160.341px 80.4831px",
            }}
            className="prefix__animable"
            id="prefix__ell82h1pt27vi"
            fill="#fff"
            opacity={0.7}
          />
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--character-1--inject-93"
      className="prefix__animable"
      style={{
        transformOrigin: "189.838px 345.301px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--character--inject-93"
        className="prefix__animable"
        style={{
          transformOrigin: "189.838px 345.301px",
        }}
      >
        <g
          id="prefix__freepik--bottom--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "181.82px 397.727px",
          }}
        >
          <path
            style={{
              transformOrigin: "136.705px 414.175px",
            }}
            id="prefix__elahsi28jdwqk"
            className="prefix__animable"
            fill="#c8856a"
            d="M128.8 411.82l10.71-6.95 5.1 14.78-10.74 3.83-5.07-11.66z"
          />
          <path
            d="M180.65 357.58c1 14.65 3.35 31.23-.61 45.46-1.4 5-3.16 7.62-17.35 12-14.48 4.43-22.07 6.49-22.07 6.49 1.53-5.32-3.22-12.61-7.6-12.54 0 0 2.46-1.49 7.53-5 7.93-5.5 10.35-7.49 16.36-8 0 0-5.46-20.55-5.75-32.23-.16-6.45 29.49-6.18 29.49-6.18z"
            style={{
              transformOrigin: "157.639px 389.554px",
            }}
            id="prefix__eln9if83t4ec"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M164.44 409.44c8-3.47 8.21-4.45 9-8.55s-1.24-22-5.43-34.2l.84-.29c4.12 12 6.32 30.07 5.47 34.65s-1.32 5.67-9.5 9.21c-6.52 2.81-19.56 5.93-24.11 7-.06-.29-.14-.57-.22-.86 4.51-1.06 17.51-4.17 23.95-6.96z"
            id="prefix__elhbxtqvm4si"
            className="prefix__animable"
            style={{
              transformOrigin: "157.495px 391.83px",
            }}
          />
          <path
            d="M144.4 420.68l-4.08 1a11.9 11.9 0 00-1.81-8.49c-2.77-4.29-6-4.07-6-4.07l3.8-2.6a9.88 9.88 0 016.86 5.15 12.21 12.21 0 011.23 9.01z"
            style={{
              transformOrigin: "138.639px 414.1px",
            }}
            id="prefix__el4pc1x5eeiak"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M155.2 396.12a17 17 0 011.71-.21c1.76 4.48 6.23 6.36 11.43 6.62-4.34 1.71-11.26-.53-13.14-6.41z"
            id="prefix__elc3llxsrkwqt"
            className="prefix__animable"
            style={{
              transformOrigin: "161.77px 399.499px",
            }}
          />
          <path
            d="M118.9 434.85s5.9 5.83 8.37 7.93a4.27 4.27 0 00.46.35 4.49 4.49 0 004.75-.12 7.87 7.87 0 00-.12-8.87s-.36-.05.28-2.77c.4-1.94.84-3.91 1.42-5.81a2.47 2.47 0 011.41-1.75c.75-.43 1.95-.79 2.42-1.57s-2 .05-1.92-.8.26-2.22.27-3.23a6.16 6.16 0 00-1.24-3.63c-1.29-1.59-3.22-3.83-5.32-3.36-.92.21-.41.56-3.34 1.73-1.24.49-3.09.08-4.62 2.07-.09.12-2.82 19.83-2.82 19.83z"
            style={{
              transformOrigin: "128.425px 427.454px",
            }}
            id="prefix__elxlh31k42esb"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M132.36 434.14a11.05 11.05 0 01.63 1.49 10 10 0 01-.52 7.37c5 .57 6.85-2 6.85-2s.78-2.38-1.67-4.73a6.7 6.7 0 00-.94-.78h-.05a7.33 7.33 0 00-4.3-1.35z"
            style={{
              transformOrigin: "135.899px 438.611px",
            }}
            id="prefix__el1yksi8nhn1kh"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M119.89 415.48c-1.39.23-1.44 4.85-1.33 8.41s.3 4.85-.7 7.59-1.49 3.95-.56 5.23 9.21 7.46 9.21 7.46a34.48 34.48 0 01.16-11c1.06-6.31 1.48-10.43-.83-13.88a8.7 8.7 0 00-5.95-3.81z"
            style={{
              transformOrigin: "122.164px 429.825px",
            }}
            id="prefix__el61y7xvcia76"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M139.33 441a17.35 17.35 0 01-8.34 1.75c-4.18-.38-4.06-2-3.49-6.93s1.81-11.67.51-15-5-5.84-6.29-5.8a3 3 0 00-1.83.46s3 .43 5.26 4.28c1.88 3.13 1.41 8.4.53 13.21s-1.82 10.41 1.88 11.79a14.2 14.2 0 0011.06-1 2 2 0 00.71-2.76z"
            style={{
              transformOrigin: "129.753px 430.228px",
            }}
            id="prefix__elv5b8g7gdv49"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M132.44 432.3a1.37 1.37 0 01.38 1 2.8 2.8 0 01-1.91 2.23c-.57.19-1 0 .05-.86a5.32 5.32 0 001.48-2.37z"
            style={{
              transformOrigin: "131.57px 433.949px",
            }}
            id="prefix__el81ft8rn52lj"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M133.22 428.94a1.2 1.2 0 01.19.81 4.23 4.23 0 01-2.23 2.29c-1 .21-.29-.68.22-1.05a18.87 18.87 0 001.82-2.05z"
            style={{
              transformOrigin: "132.047px 430.506px",
            }}
            id="prefix__el12g0kntyir4"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M134.21 425.27a.85.85 0 01.3.69c0 .4-2.18 1.4-2.75 1.23s-.67-.38.15-.71 2.3-1.21 2.3-1.21z"
            style={{
              transformOrigin: "132.912px 426.24px",
            }}
            id="prefix__eldlciytojmhv"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M246.61 420.85a6.27 6.27 0 01.1 2.91c-.22.76-1.83 3.24-6.61 4.92-4.27 1.5-9.63.92-12.18.61-3.47-.42-5.07 1.08-10 1.85a10.73 10.73 0 01-8.77-2.29 2.67 2.67 0 01-.59-2.13c.08-1.7.21-1.48.41-1.46z"
            style={{
              transformOrigin: "227.681px 426.082px",
            }}
            id="prefix__elobja5k5x35a"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M209.64 420.2c-.09.33-.16.67-.23 1a17.38 17.38 0 00-.4 5.23 4.76 4.76 0 003.09 2.36 13.18 13.18 0 007.29.46c2-.41 4.84-1.73 7.25-1.55a49.73 49.73 0 007.9.39 21.33 21.33 0 005.18-.88 11.17 11.17 0 006.79-5.17c.19-3.31-2.5-5.48-4.43-6.32-4.66-2-9.92-.22-9.92-.22l-1.1.08c-1.7.12-3.68.3-5-.44a3.18 3.18 0 01-1.4-1.52c-.35-.79-.47-1.49-1.18-1.57 0 0-9.86-1.14-12.06.64-.76.61-1 3.46-1.12 4.28-.12.65-.15 1.34-.32 2-.13.39-.24.81-.34 1.23z"
            style={{
              transformOrigin: "227.74px 420.626px",
            }}
            id="prefix__elccu2y7ndra"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M229.9 415.67c1.29-.2 4.94 2.32 5.22 4.63-.33.59-1.11.43-1.52.18-.67-1.7-2-4.29-4.73-4.78z"
            style={{
              transformOrigin: "231.995px 418.182px",
            }}
            id="prefix__ely999w79zp3i"
            className="prefix__animable"
            fill="#fff"
          />
          <path
            d="M232.16 415.51c1-.05 5.25 1.23 6.85 4.17 1.71 3.14.71 7.54.71 7.54a12.87 12.87 0 005.66-3.3 4.19 4.19 0 00.92-4.45 7.22 7.22 0 00-2.18-2.79c-2-1.56-3.87-2-7.54-2a12.28 12.28 0 00-5.54.95z"
            style={{
              transformOrigin: "238.811px 420.939px",
            }}
            id="prefix__elnxyqrpoqnd"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M227.41 415.53c1.23.39 4.2 2.31 4.49 4.62-.33.59-1.11.42-1.52.18-.25-1.68-1.17-3.78-4.47-5.26z"
            style={{
              transformOrigin: "228.905px 417.811px",
            }}
            id="prefix__el0b6dt5sp3nfa"
            className="prefix__animable"
            fill="#fff"
          />
          <path
            d="M226.92 399.82s-2.38 12.41-2.61 13.46a7.34 7.34 0 00.38 3.6c.19.58-1.15 1-2.49-.25a16.75 16.75 0 00-7.5-3.7 8.27 8.27 0 00-3.29-.23l1.26-18.82z"
            style={{
              transformOrigin: "219.165px 405.661px",
            }}
            id="prefix__el5d2g4gxdzxo"
            className="prefix__animable"
            fill="#c8856a"
          />
          <path
            d="M234.67 358.29c2.12 4.76.8 14-1.48 24s-7.49 26.26-7.49 26.26c-.59 1.69-12 2.29-14.2-1.59 0 0 .3-9.53.57-17.49.3-8.76.09-15 3.17-20s18.87-11.16 18.87-11.16"
            style={{
              transformOrigin: "223.619px 384.075px",
            }}
            id="prefix__elinlk0qosgfo"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M188 356.14c16.06-2.94 34.93-6.86 43.17-1.72 7.23 4.51 3.61 13.31-.16 16.39s-27.12 14-42 15.47c-13.43 1.29-20.45-3.45-23.19-5.58 0 0-5.4.07-10.46-5.44-5.6-6.1-4.29-16.06-3.78-25.25z"
            style={{
              transformOrigin: "193.203px 368.255px",
            }}
            id="prefix__els13wbl1ytq"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M179.47 383a2.16 2.16 0 00.83-.08c1.16-.45 3.36-2.82 4.12-4.73a2.31 2.31 0 00.14-1.79 13.34 13.34 0 00-.95-1.52 23.72 23.72 0 01-3.85-8.48.23.23 0 00-.27-.17.24.24 0 00-.17.27 24.15 24.15 0 003.92 8.62 12 12 0 01.91 1.47A1.83 1.83 0 01184 378a10.13 10.13 0 01-3.87 4.48c-1.32.52-8.87-2.11-10.9-3.79s-4.92-7.48-5.19-13.25a.21.21 0 00-.23-.21.22.22 0 00-.21.23c.27 5.89 3.29 11.88 5.35 13.57 1.79 1.48 7.96 3.83 10.52 3.97z"
            style={{
              transformOrigin: "174.139px 374.12px",
            }}
            id="prefix__elkmahlb48ak"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M155 377h.1c.43-.19 2.28-2.29 1.84-3.92a38.69 38.69 0 01-1.28-11.34.23.23 0 00-.45 0 39.36 39.36 0 001.3 11.47c.37 1.38-1.32 3.28-1.59 3.4a.23.23 0 00-.11.3.23.23 0 00.19.09z"
            style={{
              transformOrigin: "155.899px 369.279px",
            }}
            id="prefix__eloq0rrjjj2jk"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M229.21 368.78c-1 4.89-4.17 10.41-16.56 14.14v-3.16c2.16-.76 12.76-4.03 16.56-10.98z"
            style={{
              transformOrigin: "220.93px 375.85px",
            }}
            id="prefix__elzag77ilpsy"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M189.86 357.77c.7 4.71 2.14 7.8 4.4 9.42 2 1.47 4.84 1.85 8.58 1.19 3.43-.61 7.1-1.55 10.64-2.45 7.8-2 14.53-3.71 16.85-1.54 2.17 2 2.4 5.94.91 15.46-1.09 7-6.73 23-8.18 29.77q-.44.08-.93.12c1.41-6.61 7.13-23 8.23-30 1.44-9.18 1.28-12.89-.64-14.68s-8.79-.1-16 1.75c-3.56.91-7.24 1.84-10.7 2.46-4 .71-7 .28-9.26-1.34-2.47-1.77-4-5.05-4.76-10z"
            style={{
              transformOrigin: "210.595px 383.755px",
            }}
            id="prefix__el14itpff9xsv"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M227 404.39s-2.35 1.36-7.73 1.33-7.67-2.72-7.67-2.72l-.35 6s1.25 1.91 6.95 2.31 7.24-1.12 7.24-1.12z"
            style={{
              transformOrigin: "219.125px 407.189px",
            }}
            id="prefix__el23braxzekbo"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M166 382l.57-.68c-8.64-7.18-7.66-17-5.57-25.59l-.86-.21c-1.3 5.37-4.35 17.97 5.86 26.48z"
            style={{
              transformOrigin: "162.628px 368.76px",
            }}
            id="prefix__elgl0dygw5zfm"
            className="prefix__animable"
            fill="#263238"
          />
        </g>
        <g
          id="prefix__freepik--top--inject-93"
          className="prefix__animable"
          style={{
            transformOrigin: "207.126px 303.873px",
          }}
        >
          <path
            d="M170.54 292.28l26 11.79c4-2.72 7.91-5.5 11.78-8.36 2.72-2.06 7-4.95 8.9-7.5 1.22-2.21.76-5.1 1.6-7.46a49.6 49.6 0 002.29-7.09 1 1 0 011.22-.23c2.18 1.6.73 5.37 1.08 7.64.22.94 1.45-.31 1.68-.72 2.2-3.09 3.07-6.77 4.12-10.33.41-1.1 1.73-2.82 2.95-1.92.47.88 0 2 .05 2.91s1 1.9 1 3a2.89 2.89 0 00.52 2.09c.53 1.06.25 2.25.2 3.37-.2 6.48-5 11.58-9.08 16-3.17 3.48-12.27 14.9-20.88 23.72-4.61 4.62-8.48 1.79-14.12-.1C180.58 316 160 307.77 160 307.77z"
            style={{
              transformOrigin: "197.024px 294.772px",
            }}
            id="prefix__ele68rnudoski"
            className="prefix__animable"
            fill="#af6152"
          />
          <path
            d="M171.89 290.63c-7.66-1.32-11.23 1.18-13.54 4-2 2.41-5 7.79-1.49 23.61z"
            style={{
              transformOrigin: "163.566px 304.254px",
            }}
            id="prefix__elhyoe5iswt9n"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M161.76 295.8c3.5-4.46 7.06-5.25 11.76-5.17 1 0 3.52.15 3.52.15.43 2.2 8 2.59 13.72 1.52 1.7.53 8.65 2.68 10.05 3.23 4 1.55 8.74 7.64 4.53 22.25s-5 25.77-3.79 40.32c-4.87 4.22-16.24 5-24.17 4.22-17.08-1.62-26-10.85-26-10.85a339.12 339.12 0 014.62-40.61c1.64-9.04 4.2-13.07 5.76-15.06z"
            style={{
              transformOrigin: "179.182px 326.606px",
            }}
            id="prefix__ela87xwjjo2yb"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M230.53 315.4c3.41-2.81 9.62-7.63 13.62-11.71a12.58 12.58 0 003.14-5.87c.82-2.94 2.17-6.11 2.3-8.75.18-3.46 1.55-2.72 2.44-1.47.82 1.46.53 4.09.78 5.7.75 4 4.7-3.26 5.14-4.37 1-2-.45-8.23 2.3-8.85a.45.45 0 01.49.32 20.23 20.23 0 01.4 3 27.43 27.43 0 01.5 6c0 1.05 1.05 2 1.14 3a22.43 22.43 0 000 2.46c.43 1.76-.67 6.69-3.11 9.31-1.91 2.24-3 2.8-5.46 5.28-1.39 1.41-3.62 4.51-6.86 8.73-2.22 2.89-7.83 10-10.58 12.46s-6.19 4.14-11.43 1.28c-7.94-4.34-22.2-13.91-22.2-13.91-9.13-5.81-7.34-18.72-3.86-23 4.76 1.64 8.5 2.72 14 6.85 9.92 7.53 17.25 13.54 17.25 13.54z"
            style={{
              transformOrigin: "229.66px 306.748px",
            }}
            id="prefix__el8snkvcw32iy"
            className="prefix__animable"
            fill="#c8856a"
          />
          <path
            d="M230.53 315.4c4.78 4.13 4.29 8.57 4.29 8.57s1.63-4.8-2.62-9.88z"
            style={{
              transformOrigin: "232.829px 319.03px",
            }}
            id="prefix__eliz2en9qazcn"
            className="prefix__animable"
            fill="#af6152"
          />
          <path
            d="M198.76 294.82c7.27 1.95 9.89 2.92 13.38 5.63s13.69 10.66 13.69 10.66 2.15 5.43.66 10.68c-1.58 5.58-6.39 7.48-7.9 6.66l-16.69-10.9s-4.09-2.69-5.42-9.7c-.65-3.41-1.31-10.91 2.28-13.03z"
            style={{
              transformOrigin: "211.492px 311.726px",
            }}
            id="prefix__elxtz17b0l4bi"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M223.33 309.16s.67-.55 2.07 0a19.39 19.39 0 015.71 4.86c1.7 3.13 1.7 7.49.32 11.53s-4.88 7.13-6.45 6.9a12.73 12.73 0 01-5.28-1.89c-1.82-1.19-3.3-2.2-2.79-3.22l1 .67s3.41-.22 6.12-5.28.75-12.43.75-12.43z"
            style={{
              transformOrigin: "224.618px 320.689px",
            }}
            id="prefix__ele21apchqxb"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M191.45 285.41l-.52 6.95c-5.18 2.84-16.07 1.44-16.41-1.14l.65-7.57z"
            style={{
              transformOrigin: "182.985px 288.79px",
            }}
            id="prefix__el49irx0k7oas"
            className="prefix__animable"
            fill="#c8856a"
          />
          <path
            d="M199.68 265.63a57.53 57.53 0 014.18 6.61 7.56 7.56 0 01-3 1.9z"
            style={{
              transformOrigin: "201.77px 269.885px",
            }}
            id="prefix__el6nszlf244yt"
            className="prefix__animable"
            fill="#af6152"
          />
          <path
            d="M189.26 252.94c5.12-.08 11 3.51 10.69 13.08 0 2 .8 3.67 1.12 6.46.76 6.69-.61 10.25-1.66 11.55-3 2-6.25 2.56-10.77 1.75-3.44-.61-12.18-2.48-16.23-7.58-4.77-6-6.66-14.54-2.52-18.5 5.84-5.58 16.66-6.7 19.37-6.76z"
            style={{
              transformOrigin: "184.45px 269.538px",
            }}
            id="prefix__elhj5lmzqo0lo"
            className="prefix__animable"
            fill="#c8856a"
          />
          <path
            d="M199.41 284c-1.12 1.5-5.22 2.69-8 2.61l.14-2.23s5.45.8 7.86-.38z"
            style={{
              transformOrigin: "195.41px 285.307px",
            }}
            id="prefix__elihsqjvxnpra"
            className="prefix__animable"
            fill="#af6152"
          />
          <path
            d="M192.32 260.05a4.07 4.07 0 01-.45 2.52 5 5 0 01-2.69 2.29 10 10 0 011.56 4.4 2.43 2.43 0 01-.18 1.44 1 1 0 01-1.7.12 11.81 11.81 0 00-1.63-2.23 4.62 4.62 0 00-3-1.3c-4.22-.06-3.71 5.42-1.83 7.48 3.07 3.38 5.12.89 5.12.89s1.92 5.43-1.9 8.16c0 0-5.57 2.29-10.22.41a65.16 65.16 0 01-7.77-10.08c-5-8.18-4-14.93-1-17.44.21-3.51 2.3-5.74 5.34-7.12 4.14-1.88 8.42-.87 12.8-1.26a14.92 14.92 0 006.33-2.06c.84-.52 3-1.43 3.92-1a1.78 1.78 0 01.76.86 4.52 4.52 0 01-.43 3.47 4.22 4.22 0 013.52 1c1.48 1.17 2 3.33 1.59 5.53-.2 1.47-2.16 5.09-8.14 3.92z"
            style={{
              transformOrigin: "182.363px 265.065px",
            }}
            id="prefix__eld0e7hriuu95"
            className="prefix__animable"
            fill="#263238"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter id="prefix__active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="prefix__hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="red" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" />
      </filter>
    </defs>
  </svg>
);

export default AboutUSVG;
